/**-----------------------------------------------------------------------------------------
* Copyright © 2020 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { EventEmitter, Injectable, Directive, TemplateRef, forwardRef, Component, NgZone, Renderer2, ChangeDetectorRef, ElementRef, Input, ContentChild, ViewChild, Output, HostBinding, HostListener, ViewChildren, ViewContainerRef, isDevMode, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LocalizationService, L10N_PREFIX, ComponentMessages } from '@progress/kendo-angular-l10n';
import { guid, Keys, isDocumentAvailable, KendoInput, isChanged } from '@progress/kendo-angular-common';
import { fromEvent, merge } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HttpHeaders, HttpRequest, HttpEventType, HttpResponse, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';

/**
 * Lists the possible states of a file.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@progress/kendo-angular-l10n';
import * as ɵngcc3 from '@angular/common';

const _c0 = ["fileSelect"];
const _c1 = ["fileSelectButton"];
var I18N_2;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The drop zone hint
     * @meaning kendo.fileselect.dropFilesHere
     */ 
    const MSG_EXTERNAL_660278350824582724$$DIST_FESM2015_INDEX_JS_3 = goog.getMsg("Drop files here to select");
    I18N_2 = MSG_EXTERNAL_660278350824582724$$DIST_FESM2015_INDEX_JS_3;
}
else {
    I18N_2 = $localize `:kendo.fileselect.dropFilesHere|The drop zone hint␟fc9dc41483f5cb38bd14b6c7003fb09ef73aa357␟660278350824582724:Drop files here to select`;
}
var I18N_4;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid allowed extensions restriction message
     * @meaning kendo.fileselect.invalidFileExtension
     */ 
    const MSG_EXTERNAL_4664331691591215211$$DIST_FESM2015_INDEX_JS_5 = goog.getMsg("File type not allowed.");
    I18N_4 = MSG_EXTERNAL_4664331691591215211$$DIST_FESM2015_INDEX_JS_5;
}
else {
    I18N_4 = $localize `:kendo.fileselect.invalidFileExtension|The text for the invalid allowed extensions restriction message␟cd37b839ea9e6b35f63d735544dee56d4380e2f9␟4664331691591215211:File type not allowed.`;
}
var I18N_6;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid max file size restriction message
     * @meaning kendo.fileselect.invalidMaxFileSize
     */ 
    const MSG_EXTERNAL_7793317101233274017$$DIST_FESM2015_INDEX_JS_7 = goog.getMsg("File size too large.");
    I18N_6 = MSG_EXTERNAL_7793317101233274017$$DIST_FESM2015_INDEX_JS_7;
}
else {
    I18N_6 = $localize `:kendo.fileselect.invalidMaxFileSize|The text for the invalid max file size restriction message␟98382b80d6551de7650912776b22a6c70a80f7fd␟7793317101233274017:File size too large.`;
}
var I18N_8;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid min file size restriction message
     * @meaning kendo.fileselect.invalidMinFileSize
     */ 
    const MSG_EXTERNAL_6852116465202092102$$DIST_FESM2015_INDEX_JS_9 = goog.getMsg("File size too small.");
    I18N_8 = MSG_EXTERNAL_6852116465202092102$$DIST_FESM2015_INDEX_JS_9;
}
else {
    I18N_8 = $localize `:kendo.fileselect.invalidMinFileSize|The text for the invalid min file size restriction message␟448bd77b7081ff65298df29ebcfe776401613b21␟6852116465202092102:File size too small.`;
}
var I18N_10;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Remove button
     * @meaning kendo.fileselect.remove
     */ 
    const MSG_EXTERNAL_8968399983135301359$$DIST_FESM2015_INDEX_JS_11 = goog.getMsg("Remove");
    I18N_10 = MSG_EXTERNAL_8968399983135301359$$DIST_FESM2015_INDEX_JS_11;
}
else {
    I18N_10 = $localize `:kendo.fileselect.remove|The text for the Remove button␟19fcca3d504982c668a7a793a545930003c7a0a7␟8968399983135301359:Remove`;
}
var I18N_12;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Select button
     * @meaning kendo.fileselect.select
     */ 
    const MSG_EXTERNAL_3297892120691863975$$DIST_FESM2015_INDEX_JS_13 = goog.getMsg("Select files...");
    I18N_12 = MSG_EXTERNAL_3297892120691863975$$DIST_FESM2015_INDEX_JS_13;
}
else {
    I18N_12 = $localize `:kendo.fileselect.select|The text for the Select button␟fb88c598155545d9cb1e15ff76bdec63d72c03c9␟3297892120691863975:Select files...`;
}
const _c14 = ["dropFilesHere", I18N_2, "invalidFileExtension", I18N_4, "invalidMaxFileSize", I18N_6, "invalidMinFileSize", I18N_8, "remove", I18N_10, "select", I18N_12];
function FileSelectComponent_ul_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ul", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabled)("fileList", ctx_r2.fileList.files)("fileTemplate", ctx_r2.fileTemplate);
} }
const _c15 = ["kendo-upload-file-list", ""];
function FileListComponent_ng_template_0_kendo_upload_file_list_single_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-upload-file-list-single-item", 5);
} if (rf & 2) {
    const files_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.disabled)("file", files_r1[0]);
} }
function FileListComponent_ng_template_0_kendo_upload_file_list_multiple_items_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-upload-file-list-multiple-items", 6);
} if (rf & 2) {
    const files_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.disabled)("files", files_r1);
} }
function FileListComponent_ng_template_0_3_ng_template_0_Template(rf, ctx) { }
const _c16 = function (a0, a1, a2) { return { templateRef: a0, state: a1, $implicit: a2 }; };
function FileListComponent_ng_template_0_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FileListComponent_ng_template_0_3_ng_template_0_Template, 0, 0, "ng-template", 7);
} if (rf & 2) {
    const files_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("templateContext", ɵngcc0.ɵɵpureFunction3(1, _c16, ctx_r5.fileTemplate.templateRef, files_r1[0].state, files_r1));
} }
function FileListComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵtemplate(1, FileListComponent_ng_template_0_kendo_upload_file_list_single_item_1_Template, 1, 2, "kendo-upload-file-list-single-item", 2);
    ɵngcc0.ɵɵtemplate(2, FileListComponent_ng_template_0_kendo_upload_file_list_multiple_items_2_Template, 1, 2, "kendo-upload-file-list-multiple-items", 3);
    ɵngcc0.ɵɵtemplate(3, FileListComponent_ng_template_0_3_Template, 1, 5, undefined, 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const files_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("files", files_r1)("index", index_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", files_r1.length === 1 && !ctx_r0.fileTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", files_r1.length > 1 && !ctx_r0.fileTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fileTemplate);
} }
function FileListItemActionButtonComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.progress, "%");
} }
const _c17 = function (a0) { return { "k-state-focused": a0 }; };
function FileListItemActionButtonComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("focus", function FileListItemActionButtonComponent_button_2_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onFocus("retry"); })("blur", function FileListItemActionButtonComponent_button_2_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onBlur("retry"); })("click", function FileListItemActionButtonComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onRetryClick(); });
    ɵngcc0.ɵɵelement(1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c17, ctx_r1.retryFocused));
    ɵngcc0.ɵɵattribute("tabIndex", 0 - 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.retryButtonTitle)("title", ctx_r1.retryButtonTitle);
} }
const _c18 = function (a0, a1) { return { "k-i-play-sm": a0, "k-i-pause-sm": a1 }; };
function FileListItemActionButtonComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("focus", function FileListItemActionButtonComponent_button_3_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onFocus("pauseResume"); })("blur", function FileListItemActionButtonComponent_button_3_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onBlur("pauseResume"); })("click", function FileListItemActionButtonComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onPauseResumeClick(); });
    ɵngcc0.ɵɵelement(1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c17, ctx_r2.pauseResumeFocused));
    ɵngcc0.ɵɵattribute("tabIndex", 0 - 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c18, ctx_r2.isPaused, !ctx_r2.isPaused));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.pauseResumeButtonTitle)("title", ctx_r2.pauseResumeButtonTitle);
} }
const _c19 = function (a0, a1) { return { "k-i-cancel": a0, "k-delete k-i-x": a1 }; };
function FileListItemActionButtonComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("focus", function FileListItemActionButtonComponent_button_4_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onFocus("action"); })("blur", function FileListItemActionButtonComponent_button_4_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onBlur("action"); })("click", function FileListItemActionButtonComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onRemoveCancelClick(); });
    ɵngcc0.ɵɵelement(1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c17, ctx_r3.actionFocused));
    ɵngcc0.ɵɵattribute("tabIndex", 0 - 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c19, ctx_r3.isUploading, !ctx_r3.isUploading));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.actionButtonTitle)("title", ctx_r3.actionButtonTitle);
} }
const _c20 = function (a0, a1, a2) { return { "k-text-error": a0, "k-file-validation-message": a1, "k-file-size": a2 }; };
function FileListMultipleItemsComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 10);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", file_r1.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", file_r1.name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c20, file_r1.validationErrors, file_r1.validationErrors, !file_r1.validationErrors));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.fileStatusText(file_r1));
} }
const _c21 = function (a0, a1) { return { "k-text-success": a0, "k-text-error": a1 }; };
const _c22 = function (a0, a1, a2, a3, a4) { return { "k-file-validation-message": a0, "k-file-size": a1, "k-text-success": a2, "k-text-error": a3, "k-file-information": a4 }; };
var I18N_23;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Cancel button
     * @meaning kendo.upload.cancel
     */ 
    const MSG_EXTERNAL_1628868291685658590$$DIST_FESM2015_INDEX_JS_24 = goog.getMsg("Cancel");
    I18N_23 = MSG_EXTERNAL_1628868291685658590$$DIST_FESM2015_INDEX_JS_24;
}
else {
    I18N_23 = $localize `:kendo.upload.cancel|The text for the Cancel button␟262a7a2e1c2c01f72e494499e4031ca52bfb6c62␟1628868291685658590:Cancel`;
}
var I18N_25;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Clear button
     * @meaning kendo.upload.clearSelectedFiles
     */ 
    const MSG_EXTERNAL_3149650400352762187$$DIST_FESM2015_INDEX_JS_26 = goog.getMsg("Clear");
    I18N_25 = MSG_EXTERNAL_3149650400352762187$$DIST_FESM2015_INDEX_JS_26;
}
else {
    I18N_25 = $localize `:kendo.upload.clearSelectedFiles|The text for the Clear button␟47d53c4c549530374586d580a1fffb90509aa114␟3149650400352762187:Clear`;
}
var I18N_27;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The drop zone hint
     * @meaning kendo.upload.dropFilesHere
     */ 
    const MSG_EXTERNAL_6841325639465061593$$DIST_FESM2015_INDEX_JS_28 = goog.getMsg("Drop files here to upload");
    I18N_27 = MSG_EXTERNAL_6841325639465061593$$DIST_FESM2015_INDEX_JS_28;
}
else {
    I18N_27 = $localize `:kendo.upload.dropFilesHere|The drop zone hint␟ed0e4f0924eb8ac2dfc0a30d0852da2f0a356e8f␟6841325639465061593:Drop files here to upload`;
}
var I18N_29;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The status message for a batch of files
     * @meaning kendo.upload.filesBatchStatus
     */ 
    const MSG_EXTERNAL_1052757211842837603$$DIST_FESM2015_INDEX_JS_30 = goog.getMsg("files");
    I18N_29 = MSG_EXTERNAL_1052757211842837603$$DIST_FESM2015_INDEX_JS_30;
}
else {
    I18N_29 = $localize `:kendo.upload.filesBatchStatus|The status message for a batch of files␟c6ce7b0d23357eba501fa8e17eb2e2c8ce2ca81a␟1052757211842837603:files`;
}
var I18N_31;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The status message for a batch of files after failed upload
     * @meaning kendo.upload.filesBatchStatusFailed
     */ 
    const MSG_EXTERNAL_5934737755327152932$$DIST_FESM2015_INDEX_JS_32 = goog.getMsg("files failed to upload.");
    I18N_31 = MSG_EXTERNAL_5934737755327152932$$DIST_FESM2015_INDEX_JS_32;
}
else {
    I18N_31 = $localize `:kendo.upload.filesBatchStatusFailed|The status message for a batch of files after failed upload␟1b556c65fa0c566e50ca9a29984c0f2c1299f1a1␟5934737755327152932:files failed to upload.`;
}
var I18N_33;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The status message for a batch of files after successful upload
     * @meaning kendo.upload.filesBatchStatusUploaded
     */ 
    const MSG_EXTERNAL_4678582374156884660$$DIST_FESM2015_INDEX_JS_34 = goog.getMsg("files successfully uploaded.");
    I18N_33 = MSG_EXTERNAL_4678582374156884660$$DIST_FESM2015_INDEX_JS_34;
}
else {
    I18N_33 = $localize `:kendo.upload.filesBatchStatusUploaded|The status message for a batch of files after successful upload␟799ee1c7cad3b2114cfbf5cdc4811d87261a2ed8␟4678582374156884660:files successfully uploaded.`;
}
var I18N_35;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The file status message after failed upload
     * @meaning kendo.upload.fileStatusFailed
     */ 
    const MSG_EXTERNAL_372927175642445287$$DIST_FESM2015_INDEX_JS_36 = goog.getMsg("File failed to upload.");
    I18N_35 = MSG_EXTERNAL_372927175642445287$$DIST_FESM2015_INDEX_JS_36;
}
else {
    I18N_35 = $localize `:kendo.upload.fileStatusFailed|The file status message after failed upload␟4a3deae307b634742b5b7d7790c22e60ddd83668␟372927175642445287:File failed to upload.`;
}
var I18N_37;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The file status message after successful upload
     * @meaning kendo.upload.fileStatusUploaded
     */ 
    const MSG_EXTERNAL_6873833183057253097$$DIST_FESM2015_INDEX_JS_38 = goog.getMsg("File successfully uploaded.");
    I18N_37 = MSG_EXTERNAL_6873833183057253097$$DIST_FESM2015_INDEX_JS_38;
}
else {
    I18N_37 = $localize `:kendo.upload.fileStatusUploaded|The file status message after successful upload␟967a89b151d61724cee57583e4c5f50cd5419369␟6873833183057253097:File successfully uploaded.`;
}
var I18N_39;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The header status message when the file upload is paused
     * @meaning kendo.upload.headerStatusPaused
     */ 
    const MSG_EXTERNAL_3443987862990095035$$DIST_FESM2015_INDEX_JS_40 = goog.getMsg("Paused");
    I18N_39 = MSG_EXTERNAL_3443987862990095035$$DIST_FESM2015_INDEX_JS_40;
}
else {
    I18N_39 = $localize `:kendo.upload.headerStatusPaused|The header status message when the file upload is paused␟940cf4e04c5b4fd5e98b4affd35a4b2c9c3036a4␟3443987862990095035:Paused`;
}
var I18N_41;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The header status message after file upload completion
     * @meaning kendo.upload.headerStatusUploaded
     */ 
    const MSG_EXTERNAL_9210921126598204924$$DIST_FESM2015_INDEX_JS_42 = goog.getMsg("Done");
    I18N_41 = MSG_EXTERNAL_9210921126598204924$$DIST_FESM2015_INDEX_JS_42;
}
else {
    I18N_41 = $localize `:kendo.upload.headerStatusUploaded|The header status message after file upload completion␟30d5eeceb66bae90056d593fcf90eecd851b36a4␟9210921126598204924:Done`;
}
var I18N_43;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The header status message during file upload
     * @meaning kendo.upload.headerStatusUploading
     */ 
    const MSG_EXTERNAL_6336385612571616916$$DIST_FESM2015_INDEX_JS_44 = goog.getMsg("Uploading...");
    I18N_43 = MSG_EXTERNAL_6336385612571616916$$DIST_FESM2015_INDEX_JS_44;
}
else {
    I18N_43 = $localize `:kendo.upload.headerStatusUploading|The header status message during file upload␟be0775f64ce53906c132f6b5a50280ff5b948b35␟6336385612571616916:Uploading...`;
}
var I18N_45;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid allowed extensions restriction message
     * @meaning kendo.upload.invalidFileExtension
     */ 
    const MSG_EXTERNAL_2924979995055776233$$DIST_FESM2015_INDEX_JS_46 = goog.getMsg("File type not allowed.");
    I18N_45 = MSG_EXTERNAL_2924979995055776233$$DIST_FESM2015_INDEX_JS_46;
}
else {
    I18N_45 = $localize `:kendo.upload.invalidFileExtension|The text for the invalid allowed extensions restriction message␟8292c7f6c967dcade8639d0dd477a67ad08457c7␟2924979995055776233:File type not allowed.`;
}
var I18N_47;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid max file size restriction message
     * @meaning kendo.upload.invalidMaxFileSize
     */ 
    const MSG_EXTERNAL_6669611501469754964$$DIST_FESM2015_INDEX_JS_48 = goog.getMsg("File size too large.");
    I18N_47 = MSG_EXTERNAL_6669611501469754964$$DIST_FESM2015_INDEX_JS_48;
}
else {
    I18N_47 = $localize `:kendo.upload.invalidMaxFileSize|The text for the invalid max file size restriction message␟1d3c53a4169aceb03929a0dcdd2f4c5436aa4470␟6669611501469754964:File size too large.`;
}
var I18N_49;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the invalid min file size restriction message
     * @meaning kendo.upload.invalidMinFileSize
     */ 
    const MSG_EXTERNAL_4319370666600195324$$DIST_FESM2015_INDEX_JS_50 = goog.getMsg("File size too small.");
    I18N_49 = MSG_EXTERNAL_4319370666600195324$$DIST_FESM2015_INDEX_JS_50;
}
else {
    I18N_49 = $localize `:kendo.upload.invalidMinFileSize|The text for the invalid min file size restriction message␟dde6c68c96cf06aab654c8054c516d0d12f6309a␟4319370666600195324:File size too small.`;
}
var I18N_51;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Pause button
     * @meaning kendo.upload.pause
     */ 
    const MSG_EXTERNAL_2303075305806756763$$DIST_FESM2015_INDEX_JS_52 = goog.getMsg("Pause");
    I18N_51 = MSG_EXTERNAL_2303075305806756763$$DIST_FESM2015_INDEX_JS_52;
}
else {
    I18N_51 = $localize `:kendo.upload.pause|The text for the Pause button␟8a0a61519fec031579cf6b1c4f31c94578bd0981␟2303075305806756763:Pause`;
}
var I18N_53;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Remove button
     * @meaning kendo.upload.remove
     */ 
    const MSG_EXTERNAL_8941644637700654622$$DIST_FESM2015_INDEX_JS_54 = goog.getMsg("Remove");
    I18N_53 = MSG_EXTERNAL_8941644637700654622$$DIST_FESM2015_INDEX_JS_54;
}
else {
    I18N_53 = $localize `:kendo.upload.remove|The text for the Remove button␟1e81e5de447f5792cd15c18c435360a7b946ac70␟8941644637700654622:Remove`;
}
var I18N_55;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Resume button
     * @meaning kendo.upload.resume
     */ 
    const MSG_EXTERNAL_4056147860620862675$$DIST_FESM2015_INDEX_JS_56 = goog.getMsg("Resume");
    I18N_55 = MSG_EXTERNAL_4056147860620862675$$DIST_FESM2015_INDEX_JS_56;
}
else {
    I18N_55 = $localize `:kendo.upload.resume|The text for the Resume button␟f9ef89f76dd3d8c5a3184830d60e4d4f9c4dc998␟4056147860620862675:Resume`;
}
var I18N_57;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Retry button
     * @meaning kendo.upload.retry
     */ 
    const MSG_EXTERNAL_8567960350691997515$$DIST_FESM2015_INDEX_JS_58 = goog.getMsg("Retry");
    I18N_57 = MSG_EXTERNAL_8567960350691997515$$DIST_FESM2015_INDEX_JS_58;
}
else {
    I18N_57 = $localize `:kendo.upload.retry|The text for the Retry button␟9150dfa816d23dfa75f231ca6f053f5e0ae26713␟8567960350691997515:Retry`;
}
var I18N_59;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Select button
     * @meaning kendo.upload.select
     */ 
    const MSG_EXTERNAL_2943392613806104166$$DIST_FESM2015_INDEX_JS_60 = goog.getMsg("Select files...");
    I18N_59 = MSG_EXTERNAL_2943392613806104166$$DIST_FESM2015_INDEX_JS_60;
}
else {
    I18N_59 = $localize `:kendo.upload.select|The text for the Select button␟24063b06532dc5303d28524d6245ba6d3eed80c1␟2943392613806104166:Select files...`;
}
var I18N_61;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the Upload files button
     * @meaning kendo.upload.uploadSelectedFiles
     */ 
    const MSG_EXTERNAL_4936937427147701307$$DIST_FESM2015_INDEX_JS_62 = goog.getMsg("Upload");
    I18N_61 = MSG_EXTERNAL_4936937427147701307$$DIST_FESM2015_INDEX_JS_62;
}
else {
    I18N_61 = $localize `:kendo.upload.uploadSelectedFiles|The text for the Upload files button␟3449491aa76964a8dceb9ed3957b6fc4c17f568f␟4936937427147701307:Upload`;
}
const _c63 = ["cancel", I18N_23, "clearSelectedFiles", I18N_25, "dropFilesHere", I18N_27, "filesBatchStatus", I18N_29, "filesBatchStatusFailed", I18N_31, "filesBatchStatusUploaded", I18N_33, "fileStatusFailed", I18N_35, "fileStatusUploaded", I18N_37, "headerStatusPaused", I18N_39, "headerStatusUploaded", I18N_41, "headerStatusUploading", I18N_43, "invalidFileExtension", I18N_45, "invalidMaxFileSize", I18N_47, "invalidMinFileSize", I18N_49, "pause", I18N_51, "remove", I18N_53, "resume", I18N_55, "retry", I18N_57, "select", I18N_59, "uploadSelectedFiles", I18N_61];
function UploadComponent_kendo_upload_status_total_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-upload-status-total", 10);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fileList", ctx_r2.fileList);
} }
function UploadComponent_ul_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ul", 11);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.disabled)("fileList", ctx_r3.fileList.files)("fileTemplate", ctx_r3.fileTemplate);
} }
function UploadComponent_kendo_upload_action_buttons_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-upload-action-buttons", 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.disabled);
} }
var I18N_64;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc Sets the external drop-zone hint
     * @meaning kendo.uploaddropzone.externalDropFilesHere
     */ 
    const MSG_EXTERNAL_4908353240416682626$$DIST_FESM2015_INDEX_JS_65 = goog.getMsg("Drag and drop files here to upload");
    I18N_64 = MSG_EXTERNAL_4908353240416682626$$DIST_FESM2015_INDEX_JS_65;
}
else {
    I18N_64 = $localize `:kendo.uploaddropzone.externalDropFilesHere|Sets the external drop-zone hint␟0b9299bc1023ea6dce824348625df34e3ca92374␟4908353240416682626:Drag and drop files here to upload`;
}
const _c66 = ["externalDropFilesHere", I18N_64];
const _c67 = ["*"];
const _c68 = ["clearButton"];
const _c69 = ["uploadButton"];
const _c70 = function (a0, a1, a2, a3) { return { "k-i-checkmark": a0, "k-i-exception": a1, "k-i-upload": a2, "k-i-pause-sm": a3 }; };
var FileState;
(function (FileState) {
    /**
     * The file upload process has failed.
     */
    FileState[FileState["Failed"] = 0] = "Failed";
    /**
     * An initially selected fake file without a set state.
     */
    FileState[FileState["Initial"] = 1] = "Initial";
    /**
     * The file is selected.
     */
    FileState[FileState["Selected"] = 2] = "Selected";
    /**
     * The file is successfully uploaded.
     */
    FileState[FileState["Uploaded"] = 3] = "Uploaded";
    /**
     * The file is in the process of uploading.
     */
    FileState[FileState["Uploading"] = 4] = "Uploading";
    /**
     * The file upload process has been paused.
     */
    FileState[FileState["Paused"] = 5] = "Paused";
})(FileState || (FileState = {}));

/**
 * @hidden
 */
class FileMap {
    constructor() {
        this._files = {};
    }
    add(file) {
        let uid = file.uid;
        if (this.has(uid)) {
            if (file.validationErrors && file.validationErrors.length > 0) {
                this._files[uid].unshift(file);
            }
            else {
                this._files[uid].push(file);
            }
        }
        else {
            this._files[uid] = [file];
        }
    }
    remove(uid) {
        if (this.has(uid)) {
            this._files[uid] = null;
            delete this._files[uid];
        }
    }
    clear() {
        let allFiles = this._files;
        for (let uid in allFiles) {
            if (allFiles.hasOwnProperty(uid)) {
                for (let file of allFiles[uid]) {
                    if (file.httpSubscription) {
                        file.httpSubscription.unsubscribe();
                    }
                }
                allFiles[uid] = null;
                delete allFiles[uid];
            }
        }
    }
    has(uid) {
        return uid in this._files;
    }
    get(uid) {
        return this._files[uid];
    }
    setFilesState(files, state$$1) {
        for (let file of files) {
            this.setFilesStateByUid(file.uid, state$$1);
        }
    }
    setFilesStateByUid(uid, state$$1) {
        this.get(uid).forEach((f) => {
            f.state = state$$1;
        });
    }
    get count() {
        return Object.getOwnPropertyNames(this._files).length;
    }
    get files() {
        let initial = this._files;
        let transformed = [];
        for (let uid in initial) {
            if (initial.hasOwnProperty(uid)) {
                transformed.push(initial[uid]);
            }
        }
        return transformed;
    }
    get filesFlat() {
        let initial = this._files;
        let transformed = [];
        for (let uid in initial) {
            if (initial.hasOwnProperty(uid)) {
                let current = initial[uid];
                current.forEach((file) => {
                    transformed.push(file);
                });
            }
        }
        return transformed;
    }
    get filesToUpload() {
        let files = this._files;
        let notUploaded = [];
        for (let uid in files) {
            if (files.hasOwnProperty(uid)) {
                let currentFiles = files[uid];
                let currentFilesValid = true;
                for (let file of currentFiles) {
                    if (file.state !== FileState.Selected || (file.validationErrors && file.validationErrors.length > 0)) {
                        currentFilesValid = false;
                    }
                }
                if (currentFilesValid) {
                    notUploaded.push(currentFiles);
                }
            }
        }
        return notUploaded;
    }
    get firstFileToUpload() {
        let files = this._files;
        for (let uid in files) {
            if (files.hasOwnProperty(uid)) {
                let currentFiles = files[uid];
                let currentFilesValid = true;
                for (let file of currentFiles) {
                    if (file.state !== FileState.Selected || (file.validationErrors && file.validationErrors.length > 0)) {
                        currentFilesValid = false;
                    }
                }
                if (currentFilesValid) {
                    return currentFiles;
                }
            }
        }
        return null;
    }
    hasFileWithState(fileStates) {
        let files = this._files;
        for (let uid in files) {
            if (files.hasOwnProperty(uid)) {
                let currentFiles = files[uid];
                for (let file of currentFiles) {
                    if (fileStates.indexOf(file.state) >= 0) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}

/**
 * Arguments for the `cancel` event. The `cancel` event fires when
 * the user cancels the process of uploading a file or a batch of files.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <p>Click the <span class='k-icon k-i-cancel'></span> icon during upload to trigger the event</p>
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (cancel)="cancelEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    cancelEventHandler(e: CancelEvent) {
 *      console.log('Canceling file upload', e.files);
 *    }
 *  }
 * ```
 */
class CancelEvent {
    /**
     * Constructs the event arguments for the `cancel` event.
     * @param files - The list of the files that were going to be uploaded.
     */
    constructor(files) {
        this.files = files;
    }
}

/**
 * @hidden
 */
class PreventableEvent {
    constructor() {
        this.prevented = false;
    }
    /**
     * Prevents the default action for a specified event.
     * In this way, the source component suppresses the built-in behavior that follows the event.
     */
    preventDefault() {
        this.prevented = true;
    }
    /**
     * If the event is prevented by any of its subscribers, returns `true`.
     *
     * @returns `true` if the default action was prevented. Otherwise, returns `false`.
     */
    isDefaultPrevented() {
        return this.prevented;
    }
}

/**
 * Arguments for the `clear` event. The `clear` event fires when
 * the **Clear** button is clicked. At this point, the selected files are about to be cleared.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [autoUpload]="false"
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (clear)="clearEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    clearEventHandler(e: ClearEvent) {
 *      console.log('Clearing the file upload');
 *    }
 *  }
 * ```
 */
class ClearEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `clear` event.
     */
    constructor() { super(); }
}

/**
 * Arguments for the `error` event. The `error` event fires when
 * an `upload` or `remove` operation fails.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (error)="errorEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    errorEventHandler(e: ErrorEvent) {
 *      console.log('An error occurred');
 *    }
 *  }
 * ```
 */
class ErrorEvent {
    /**
     * Constructs the event arguments for the `error` event.
     *
     * @param files - The list of the files that failed to be uploaded or removed.
     * @param operation - The operation type (`upload` or `remove`).
     * @param response - The response object returned by the server.
     */
    constructor(files, operation, response) {
        this.files = files;
        this.operation = operation;
        this.response = response;
    }
}

/**
 * Arguments for the `pause` event. The `pause` event fires when the user
 * pauses a file that is currently uploading.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [chunkable]="true"
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (pause)="pauseEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    pauseEventHandler(ev: PauseEvent) {
 *      console.log('File paused');
 *    }
 *  }
 * ```
 *
 */
class PauseEvent {
    /**
     * Constructs the event arguments for the `pause` event.
     * @param file - The file that is going to be paused.
     */
    constructor(file) {
        this.file = file;
    }
}

/**
 * Arguments for the `remove` event. The `remove` event fires when an uploaded
 * or selected file is about to be removed. If you cancel the event, the removal is prevented.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (remove)="removeEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    removeEventHandler(e: RemoveEvent) {
 *      console.log('Removing a file');
 *    }
 *  }
 * ```
 */
class RemoveEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `remove` event.
     * @param files - The list of the files that will be removed.
     * @param headers - The headers of the request.
     */
    constructor(files, headers) {
        super();
        this.files = files;
        this.headers = headers;
    }
}

/**
 * Arguments for the `resume` event. The `resume` event fires when the user
 * resumes the upload of a file that has been previously paused.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [chunkable]="true"
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (resume)="resumeEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    resumeEventHandler(ev: ResumeEvent) {
 *      console.log('File resumed');
 *    }
 *  }
 * ```
 *
 */
class ResumeEvent {
    /**
     * Constructs the event arguments for the `resume` event.
     * @param file - The file that is going to be resumed.
     */
    constructor(file) {
        this.file = file;
    }
}

/**
 * Arguments for the `select` event. The `select` event fires when the user
 * selects a file or multiple files for upload. If you cancel the event, the selection is prevented.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (select)="selectEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    selectEventHandler(e: SelectEvent) {
 *      console.log('File selected');
 *    }
 *  }
 * ```
 */
class SelectEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `select` event.
     * @param files - The list of the selected files.
     */
    constructor(files) {
        super();
        this.files = files;
    }
}

/**
 * Arguments for the `success` event. The `success` event fires when
 * the selected files are successfully uploaded or removed.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (success)="successEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    successEventHandler(e: SuccessEvent) {
 *      console.log('The ' + e.operation + ' was successful!');
 *    }
 *  }
 * ```
 */
class SuccessEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `success` event.
     * @param files - The list of the files that were uploaded or removed.
     * @param operation - The operation type (`upload` or `remove`).
     * @param response - The response object returned by the server.
     */
    constructor(files, operation, response) {
        super();
        this.files = files;
        this.operation = operation;
        this.response = response;
    }
}

/**
 * Arguments for the `upload` event. The `upload` event fires when one or more files are about
 * to be uploaded. If you cancel the event, the upload is prevented. You can add headers to the request.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (upload)="uploadEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    uploadEventHandler(e: UploadEvent) {
 *      e.headers = e.headers.append('X-Foo', 'Bar');
 *    }
 *  }
 * ```
 */
class UploadEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `upload` event.
     * @param files - The list of the files that will be uploaded.
     * @param headers - The headers of the request.
     */
    constructor(files, headers) {
        super();
        this.files = files;
        this.headers = headers;
    }
}

/**
 * Arguments for the `uploadprogress` event. The `uploadprogress` event
 * fires when the files are in the process of uploading.
 *
 * ```ts-no-run
 *  @Component({
 *    selector: 'my-upload',
 *    template: `
 *    <kendo-upload
 *      [saveUrl]="uploadSaveUrl"
 *      [removeUrl]="uploadRemoveUrl"
 *      (uploadProgress)="uploadProgressEventHandler($event)">
 *    </kendo-upload>
 *    `
 *  })
 *  export class UploadComponent {
 *    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
 *    uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
 *
 *    uploadProgressEventHandler(e: UploadProgressEvent) {
 *      console.log(e.files[0].name + ' is ' + e.percentComplete + ' uploaded');
 *    }
 *  }
 * ```
 */
class UploadProgressEvent {
    /**
     * Constructs the event arguments for the `uploadprogress` event.
     * @param files - The list of files that are being uploaded.
     * @param percentComplete - The portion that has been uploaded.
     */
    constructor(files, percentComplete) {
        this.files = files;
        this.percentComplete = percentComplete;
    }
}

/**
 * @hidden
 */
const fileGroupMap = {
    audio: [
        ".aif", ".iff", ".m3u", ".m4a", ".mid", ".mp3", ".mpa", ".wav", ".wma", ".ogg", ".wav", ".wma", ".wpl"
    ],
    video: [
        ".3g2", ".3gp", ".avi", ".asf", ".flv", ".m4u", ".rm", ".h264", ".m4v", ".mkv", ".mov", ".mp4", ".mpg", ".rm", ".swf", ".vob", ".wmv"
    ],
    image: [
        ".ai", ".dds", ".heic", ".jpe", "jfif", ".jif", ".jp2", ".jps", ".eps", ".bmp", ".gif", ".jpeg", ".jpg", ".png", ".ps", ".psd", ".svg", ".svgz", ".tif", ".tiff"
    ],
    txt: [
        ".doc", ".docx", ".log", ".pages", ".tex", ".wpd", ".wps", ".odt", ".rtf", ".text", ".txt", ".wks"
    ],
    presentation: [
        ".key", ".odp", ".pps", ".ppt", ".pptx"
    ],
    data: [
        ".xlr", ".xls", ".xlsx"
    ],
    programming: [
        ".tmp", ".bak", ".msi", ".cab", ".cpl", ".cur", ".dll", ".dmp", ".drv", ".icns", ".ico", ".link", ".sys", ".cfg",
        ".ini", ".asp", ".aspx", ".cer", ".csr", ".css", ".dcr", ".htm", ".html", ".js", ".php", ".rss", ".xhtml"
    ],
    pdf: [
        ".pdf"
    ],
    config: [
        ".apk", ".app", ".bat", ".cgi", ".com", ".exe", ".gadget", ".jar", ".wsf"
    ],
    zip: [
        ".7z", ".cbr", ".gz", ".sitx", ".arj", ".deb", ".pkg", ".rar", ".rpm", ".tar.gz", ".z", ".zip", ".zipx"
    ],
    discImage: [
        ".dmg", ".iso", ".toast", ".vcd", ".bin", ".cue", ".mdf"
    ]
};

/* tslint:disable: no-bitwise */
/**
 * @hidden
 */
const getTotalFilesSizeMessage = (files) => {
    let totalSize = 0;
    let i;
    if (typeof files[0].size === "number") {
        for (i = 0; i < files.length; i++) {
            if (files[i].size) {
                totalSize += files[i].size;
            }
        }
    }
    else {
        return "";
    }
    totalSize /= 1024;
    if (totalSize < 1024) {
        return totalSize.toFixed(2) + " KB";
    }
    else {
        return (totalSize / 1024).toFixed(2) + " MB";
    }
};
const stripPath = (name) => {
    let slashIndex = name.lastIndexOf("\\");
    return (slashIndex !== -1) ? name.substr(slashIndex + 1) : name;
};
const getFileExtension = (fileName) => {
    const rFileExtension = /\.([^\.]+)$/;
    const matches = fileName.match(rFileExtension);
    return matches ? matches[0] : "";
};
/**
 * @hidden
 */
const validateInitialFileInfo = (file) => {
    if (file instanceof Object && file.hasOwnProperty("name")) {
        return true;
    }
    return false;
};
/**
 * @hidden
 */
const validateInitialFileSelectFile = (file) => {
    if (file instanceof File || validateInitialFileInfo(file)) {
        return true;
    }
    return false;
};
/**
 * @hidden
 */
const getInitialFileInfo = (fakeFile) => {
    fakeFile.extension = fakeFile.extension || getFileExtension(fakeFile.name);
    fakeFile.name = fakeFile.name;
    fakeFile.size = fakeFile.size || 0;
    if (!fakeFile.hasOwnProperty("state")) {
        fakeFile.state = FileState.Initial;
    }
    if (!fakeFile.hasOwnProperty("uid")) {
        fakeFile.uid = guid();
    }
    return fakeFile;
};
/**
 * @hidden
 */
const convertFileToFileInfo = (file) => {
    let fileInfo = getFileInfo(file);
    fileInfo.uid = guid();
    // Used to differentiate initial FileInfo objects and actual Files
    fileInfo.state = FileState.Selected;
    return fileInfo;
};
const getFileInfo = (rawFile) => {
    const fileName = rawFile.name;
    const fileSize = rawFile.size;
    return {
        extension: getFileExtension(fileName),
        name: fileName,
        rawFile: rawFile,
        size: fileSize,
        state: FileState.Selected
    };
};
/**
 * @hidden
 */
const getAllFileInfo = (rawFiles) => {
    let allFileInfo = new Array();
    let i;
    for (i = 0; i < rawFiles.length; i++) {
        allFileInfo.push(getFileInfo(rawFiles[i]));
    }
    return allFileInfo;
};
/**
 * @hidden
 */
const fileHasValidationErrors = (file) => {
    if (file.validationErrors && file.validationErrors.length > 0) {
        return true;
    }
    return false;
};
/**
 * @hidden
 */
const filesHaveValidationErrors = (files) => {
    for (let file of files) {
        if (fileHasValidationErrors(file)) {
            return true;
        }
    }
    return false;
};
/**
 * @hidden
 */
const inputFiles = (input) => {
    if (input.files) {
        return getAllFileInfo(input.files);
    }
    else {
        //Required for testing
        let fileNames = input.value.split("|").map((file, index) => {
            let fileName = file.trim();
            return {
                extension: getFileExtension(fileName),
                name: stripPath(fileName),
                rawFile: null,
                size: (index + 1) * 1000,
                state: FileState.Selected
            };
        });
        return fileNames;
    }
};
/**
 * @hidden
 */
const assignGuidToFiles = (files, isUnique) => {
    const uid = guid();
    return files.map((file) => {
        file.uid = isUnique ? guid() : uid;
        return file;
    });
};
const focusableRegex = /^(?:a|input|select|textarea|button|object)$/i;
/**
 * @hidden
 */
const IGNORE_TARGET_CLASSES = 'k-icon k-select k-input k-multiselect-wrap';
/**
 * @hidden
 */
const UPLOAD_CLASSES = 'k-upload-button k-clear-selected k-upload-selected k-upload-action';
const isVisible = (element) => {
    const rect = element.getBoundingClientRect();
    return !!(rect.width && rect.height) && window.getComputedStyle(element).visibility !== 'hidden';
};
const toClassList = (classNames) => String(classNames).trim().split(' ');
/**
 * @hidden
 */
const hasClasses = (element, classNames) => {
    const namesList = toClassList(classNames);
    return Boolean(toClassList(element.className).find((className) => namesList.indexOf(className) >= 0));
};
/**
 * @hidden
 */
const isFocusable = (element, checkVisibility = true) => {
    if (element.tagName) {
        const tagName = element.tagName.toLowerCase();
        const tabIndex = element.getAttribute('tabIndex');
        const validTabIndex = tabIndex !== null && !isNaN(tabIndex) && tabIndex > -1;
        let focusable = false;
        if (focusableRegex.test(tagName)) {
            focusable = !element.disabled;
        }
        else {
            focusable = validTabIndex;
        }
        return focusable && (!checkVisibility || isVisible(element));
    }
    return false;
};
/**
 * @hidden
 */
const getFileGroupCssClass = (fileExtension) => {
    const initial = 'k-i-file';
    for (let group in fileGroupMap) {
        if (fileGroupMap[group].indexOf(fileExtension) >= 0) {
            return `${initial}-${group}`;
        }
    }
    return initial;
};
/**
 * @hidden
 */
const isPresent = (value) => value !== null && value !== undefined;

/**
 * @hidden
 */
class ChunkMap {
    constructor() {
        this._files = {};
    }
    add(uid, totalChunks) {
        const initialChunkInfo = {
            index: 0,
            position: 0,
            retries: 0,
            totalChunks: totalChunks
        };
        this._files[uid] = initialChunkInfo;
        return initialChunkInfo;
    }
    remove(uid) {
        if (this.has(uid)) {
            this._files[uid] = null;
            delete this._files[uid];
        }
    }
    has(uid) {
        return uid in this._files;
    }
    get(uid) {
        return this._files[uid];
    }
}

/**
 * @hidden
 */
class UploadService {
    constructor(http) {
        this.http = http;
        this.cancelEvent = new EventEmitter();
        this.clearEvent = new EventEmitter();
        this.completeEvent = new EventEmitter();
        this.errorEvent = new EventEmitter();
        this.pauseEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
        this.resumeEvent = new EventEmitter();
        this.selectEvent = new EventEmitter();
        this.successEvent = new EventEmitter();
        this.uploadEvent = new EventEmitter();
        this.uploadProgressEvent = new EventEmitter();
        /**
         * Required for the `ControlValueAccessor` integration
         */
        this.changeEvent = new EventEmitter();
        /**
         * Default async settings
         */
        this.async = {
            autoUpload: true,
            batch: false,
            chunk: false,
            concurrent: true,
            removeField: "fileNames",
            removeHeaders: new HttpHeaders(),
            removeMethod: "POST",
            removeUrl: "",
            responseType: "json",
            saveField: "files",
            saveHeaders: new HttpHeaders(),
            saveMethod: "POST",
            saveUrl: "",
            withCredentials: true
        };
        /**
         * Default chunk settings
         */
        this.chunk = {
            autoRetryAfter: 100,
            size: 1024 * 1024,
            maxAutoRetries: 1,
            resumable: true
        };
        this.component = 'Upload';
        this.chunkMap = new ChunkMap();
        this.fileList = new FileMap();
    }
    get files() {
        return this.fileList;
    }
    setChunkSettings(settings) {
        if (settings !== false) {
            this.async.chunk = true;
            if (typeof settings === "object") {
                this.chunk = Object.assign({}, this.chunk, settings);
            }
        }
    }
    onChange() {
        let files = this.fileList.filesFlat.filter((file) => {
            return file.state === FileState.Initial ||
                file.state === FileState.Uploaded;
        });
        this.changeEvent.emit(files.length > 0 ? files : null);
    }
    addFiles(files) {
        let selectEventArgs = new SelectEvent(files);
        this.selectEvent.emit(selectEventArgs);
        if (!selectEventArgs.isDefaultPrevented()) {
            for (let file of files) {
                this.fileList.add(file);
            }
            if (this.async.autoUpload) {
                this.uploadFiles();
            }
        }
        if (this.component === 'FileSelect') {
            const flatFiles = this.fileList.filesFlat;
            this.changeEvent.emit(flatFiles.length > 0 ? flatFiles : null);
        }
    }
    addInitialFiles(initialFiles) {
        this.fileList.clear();
        initialFiles.forEach((file) => {
            let fakeFile = getInitialFileInfo(file);
            this.fileList.add(fakeFile);
        });
    }
    addInitialFileSelectFiles(initialFiles) {
        this.fileList.clear();
        initialFiles.forEach((file) => {
            if (file instanceof File) {
                this.fileList.add(convertFileToFileInfo(file));
            }
            else {
                this.fileList.add(getInitialFileInfo(file));
            }
        });
    }
    resumeFile(uid) {
        const fileToResume = this.fileList.get(uid);
        this.resumeEvent.emit(new ResumeEvent(fileToResume[0]));
        this.fileList.setFilesStateByUid(uid, FileState.Uploading);
        this._uploadFiles([fileToResume]);
    }
    pauseFile(uid) {
        let pausedFile = this.fileList.get(uid)[0];
        this.pauseEvent.emit(new PauseEvent(pausedFile));
        this.fileList.setFilesStateByUid(uid, FileState.Paused);
    }
    removeFiles(uid) {
        let removedFiles = this.fileList.get(uid);
        // Clone the Headers so that the default ones are not overridden
        let removeEventArgs = new RemoveEvent(removedFiles, this.cloneRequestHeaders(this.async.removeHeaders));
        this.removeEvent.emit(removeEventArgs);
        if (!removeEventArgs.isDefaultPrevented()) {
            if (this.component === 'Upload' &&
                (removedFiles[0].state === FileState.Uploaded ||
                    removedFiles[0].state === FileState.Initial)) {
                this.performRemove(removedFiles, removeEventArgs);
            }
            else {
                this.fileList.remove(uid);
                if (this.component === 'FileSelect') {
                    const flatFiles = this.fileList.filesFlat;
                    this.changeEvent.emit(flatFiles.length > 0 ? flatFiles : null);
                }
            }
        }
    }
    cancelFiles(uid) {
        let canceledFiles = this.fileList.get(uid);
        let cancelEventArgs = new CancelEvent(canceledFiles);
        this.cancelEvent.emit(cancelEventArgs);
        for (let file of canceledFiles) {
            if (file.httpSubscription) {
                file.httpSubscription.unsubscribe();
            }
        }
        this.fileList.remove(uid);
        this.checkAllComplete();
    }
    clearFiles() {
        let clearEventArgs = new ClearEvent();
        this.clearEvent.emit(clearEventArgs);
        if (!clearEventArgs.isDefaultPrevented()) {
            let triggerChange = this.fileList.hasFileWithState([
                FileState.Initial,
                FileState.Uploaded
            ]);
            this.fileList.clear();
            if (triggerChange) {
                this.onChange();
            }
        }
    }
    uploadFiles() {
        let filesToUpload = [];
        if (this.async.concurrent) {
            filesToUpload = this.fileList.filesToUpload;
        }
        if (!this.async.concurrent && !this.fileList.hasFileWithState([FileState.Uploading])) {
            filesToUpload = [this.fileList.firstFileToUpload];
        }
        if (filesToUpload && filesToUpload.length > 0) {
            this._uploadFiles(filesToUpload);
        }
    }
    retryFiles(uid) {
        let filesToRetry = [this.fileList.get(uid)];
        if (filesToRetry) {
            this._uploadFiles(filesToRetry);
        }
    }
    _uploadFiles(allFiles) {
        for (let filesToUpload of allFiles) {
            if (filesToUpload[0].state === FileState.Paused) {
                return;
            }
            // Clone the Headers so that the default ones are not overridden
            let uploadEventArgs = new UploadEvent(filesToUpload, this.cloneRequestHeaders(this.async.saveHeaders));
            this.uploadEvent.emit(uploadEventArgs);
            if (!uploadEventArgs.isDefaultPrevented()) {
                this.fileList.setFilesState(filesToUpload, FileState.Uploading);
                let httpSubcription = this.performUpload(filesToUpload, uploadEventArgs);
                filesToUpload.forEach((file) => {
                    file.httpSubscription = httpSubcription;
                });
            }
            else {
                this.fileList.remove(filesToUpload[0].uid);
            }
        }
    }
    performRemove(files, removeEventArgs) {
        const async = this.async;
        let fileNames = files.map((file) => {
            return file.name;
        });
        let formData = this.populateRemoveFormData(fileNames, removeEventArgs.data);
        let options = this.populateRequestOptions(removeEventArgs.headers);
        let removeRequest = new HttpRequest(async.removeMethod, async.removeUrl, formData, options);
        this.http.request(removeRequest)
            .subscribe(success => {
            this.onSuccess(success, files, "remove");
        }, error => {
            this.onError(error, files, "remove");
        });
    }
    performUpload(files, uploadEventArgs) {
        const async = this.async;
        let formData = this.populateUploadFormData(files, uploadEventArgs.data);
        let options = this.populateRequestOptions(uploadEventArgs.headers);
        let uploadRequest = new HttpRequest(async.saveMethod, async.saveUrl, formData, options);
        let httpSubscription = this.http.request(uploadRequest)
            .subscribe(event => {
            if (event.type === HttpEventType.UploadProgress && !this.async.chunk) {
                this.onProgress(event, files);
            }
            else if (event instanceof HttpResponse) {
                this.onSuccess(event, files, "upload");
                this.checkAllComplete();
            }
        }, error => {
            this.onError(error, files, "upload");
            this.checkAllComplete();
        });
        return httpSubscription;
    }
    onSuccess(successResponse, files, operation) {
        if (operation === "upload" && this.async.chunk) {
            this.onChunkProgress(files);
            if (this.isChunkUploadComplete(files[0].uid)) {
                this.removeChunkInfo(files[0].uid);
            }
            else {
                this.updateChunkInfo(files[0].uid);
                this._uploadFiles([files]);
                return;
            }
        }
        const successArgs = new SuccessEvent(files, operation, successResponse);
        this.successEvent.emit(successArgs);
        if (operation === "upload") {
            this.fileList.setFilesState(files, successArgs.isDefaultPrevented() ? FileState.Failed : FileState.Uploaded);
        }
        else {
            if (!successArgs.isDefaultPrevented()) {
                this.fileList.remove(files[0].uid);
            }
        }
        if (!successArgs.isDefaultPrevented()) {
            this.onChange();
        }
    }
    onError(errorResponse, files, operation) {
        if (operation === "upload" && this.async.chunk) {
            const maxRetries = this.chunk.maxAutoRetries;
            const chunkInfo = this.chunkMap.get(files[0].uid);
            if (chunkInfo.retries < maxRetries) {
                chunkInfo.retries += 1;
                setTimeout(() => {
                    this.retryFiles(files[0].uid);
                }, this.chunk.autoRetryAfter);
                return;
            }
        }
        const errorArgs = new ErrorEvent(files, operation, errorResponse);
        this.errorEvent.emit(errorArgs);
        if (operation === "upload") {
            this.fileList.setFilesState(files, FileState.Failed);
        }
    }
    onProgress(event, files) {
        const percentComplete = Math.round(100 * event.loaded / event.total);
        const progressArgs = new UploadProgressEvent(files, percentComplete < 100 ? percentComplete : 100);
        this.uploadProgressEvent.emit(progressArgs);
    }
    onChunkProgress(files) {
        const chunkInfo = this.chunkMap.get(files[0].uid);
        let percentComplete = 0;
        if (chunkInfo) {
            if (chunkInfo.index === chunkInfo.totalChunks - 1) {
                percentComplete = 100;
            }
            else {
                percentComplete = Math.round(((chunkInfo.index + 1) / chunkInfo.totalChunks) * 100);
            }
        }
        const progressArgs = new UploadProgressEvent(files, percentComplete < 100 ? percentComplete : 100);
        this.uploadProgressEvent.emit(progressArgs);
    }
    checkAllComplete() {
        if (!this.fileList.hasFileWithState([
            FileState.Selected,
            FileState.Uploading,
            FileState.Paused
        ])) {
            this.completeEvent.emit();
        }
        else if (this.shouldUploadNextFile()) {
            this.uploadFiles();
        }
    }
    shouldUploadNextFile() {
        return !this.async.concurrent &&
            this.fileList.hasFileWithState([FileState.Selected]) &&
            !this.fileList.hasFileWithState([FileState.Uploading]);
    }
    cloneRequestHeaders(headers) {
        let cloned = {};
        if (headers) {
            headers.keys().forEach((key) => {
                cloned[key] = headers.get(key);
            });
        }
        return new HttpHeaders(cloned);
    }
    populateRequestOptions(headers) {
        return {
            headers: headers,
            reportProgress: true,
            responseType: this.async.responseType,
            withCredentials: this.async.withCredentials
        };
    }
    populateUploadFormData(files, clientData) {
        const saveField = this.async.saveField;
        let data = new FormData();
        this.populateClientFormData(data, clientData);
        if (this.async.chunk) {
            data.append(saveField, this.getNextChunk(files[0]));
            data.append("metadata", this.getChunkMetadata(files[0]));
        }
        else {
            for (let file of files) {
                data.append(saveField, file.rawFile);
            }
        }
        return data;
    }
    populateRemoveFormData(fileNames, clientData) {
        let data = new FormData();
        this.populateClientFormData(data, clientData);
        for (let fileName of fileNames) {
            data.append(this.async.removeField, fileName);
        }
        return data;
    }
    populateClientFormData(data, clientData) {
        for (var key in clientData) {
            if (clientData.hasOwnProperty(key)) {
                data.append(key, clientData[key]);
            }
        }
    }
    /* Chunking Helper Methods Section */
    getNextChunk(file) {
        const info = this.getChunkInfo(file);
        const newPosition = info.position + this.chunk.size;
        return file.rawFile.slice(info.position, newPosition);
    }
    getChunkInfo(file) {
        let chunkInfo = this.chunkMap.get(file.uid);
        if (!chunkInfo) {
            const totalChunks = Math.ceil(file.size / this.chunk.size);
            chunkInfo = this.chunkMap.add(file.uid, totalChunks);
        }
        return chunkInfo;
    }
    updateChunkInfo(uid) {
        const chunkInfo = this.chunkMap.get(uid);
        if (chunkInfo.index < chunkInfo.totalChunks - 1) {
            chunkInfo.index += 1;
            chunkInfo.position += this.chunk.size;
            chunkInfo.retries = 0;
        }
    }
    removeChunkInfo(uid) {
        this.chunkMap.remove(uid);
    }
    getChunkMetadata(file) {
        const chunkInfo = this.chunkMap.get(file.uid);
        const chunkMetadata = {
            chunkIndex: chunkInfo.index,
            contentType: file.rawFile.type,
            fileName: file.name,
            fileSize: file.size,
            fileUid: file.uid,
            totalChunks: chunkInfo.totalChunks
        };
        return JSON.stringify(chunkMetadata);
    }
    isChunkUploadComplete(uid) {
        const chunkInfo = this.chunkMap.get(uid);
        if (chunkInfo) {
            return chunkInfo.index + 1 === chunkInfo.totalChunks;
        }
        return false;
    }
}
UploadService.ɵfac = function UploadService_Factory(t) { return new (t || UploadService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
UploadService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UploadService, factory: UploadService.ɵfac });
/** @nocollapse */
UploadService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/**
 * @hidden
 */
class NavigationService {
    constructor(uploadService) {
        this.uploadService = uploadService;
        this.onActionButtonAction = new EventEmitter();
        this.onActionButtonFocus = new EventEmitter();
        this.onFileAction = new EventEmitter();
        this.onFileFocus = new EventEmitter();
        this.onTab = new EventEmitter();
        this.onWrapperFocus = new EventEmitter();
        this.onSelectButtonFocus = new EventEmitter();
        this.actionButtonsVisible = false;
        this.focused = false;
        this._focusedIndex = -1;
    }
    action(event) {
        const key = event.keyCode;
        return this.keyBindings[key];
    }
    process(event) {
        const handler = this.action(event);
        if (handler) {
            handler(event.shiftKey);
        }
    }
    computeKeys(direction) {
        this.keyBindings = {
            [Keys.Enter]: () => this.handleEnter(),
            [Keys.Escape]: () => this.handleEscape(),
            [Keys.Delete]: () => this.handleDelete(),
            [Keys.Tab]: (shifted) => this.handleTab(shifted),
            [Keys.ArrowUp]: () => this.handleUp(),
            [Keys.ArrowDown]: () => this.handleDown(),
            [this.invertKeys(direction, Keys.ArrowLeft, Keys.ArrowRight)]: () => this.handleLeft(),
            [this.invertKeys(direction, Keys.ArrowRight, Keys.ArrowLeft)]: () => this.handleRight()
        };
    }
    invertKeys(direction, original, inverted) {
        return direction === 'rtl' ? inverted : original;
    }
    focusSelectButton() {
        this.focused = true;
        this._focusedIndex = -1;
        this.onSelectButtonFocus.emit();
    }
    handleEnter() {
        if (this.lastIndex >= 0) {
            if (this.focusedIndex <= this.lastFileIndex) {
                this.onFileAction.emit(Keys.Enter);
                return;
            }
            if (this.actionButtonsVisible && this.focusedIndex <= this.lastIndex) {
                this.onActionButtonAction.emit(this.focusedIndex < this.lastIndex ? "clear" : "upload");
            }
        }
    }
    handleDelete() {
        if (this.focusedIndex >= 0 && this.focusedIndex <= this.lastFileIndex) {
            this.onFileAction.emit(Keys.Delete);
        }
    }
    handleEscape() {
        if (this.focusedIndex >= 0 && this.focusedIndex <= this.lastFileIndex) {
            this.onFileAction.emit(Keys.Escape);
        }
    }
    handleLeft() {
        if (this.actionButtonsVisible && this.focusedIndex === this.lastIndex) {
            this.focusedIndex -= 1;
            this.onActionButtonFocus.emit("clear");
        }
    }
    handleRight() {
        if (this.actionButtonsVisible && this.focusedIndex === this.lastIndex - 1) {
            this.focusedIndex += 1;
            this.onActionButtonFocus.emit("upload");
        }
    }
    handleTab(shifted) {
        if (this.focusedIndex >= 0 && shifted) {
            this.focusedIndex = -1;
            return;
        }
        this.onTab.emit();
    }
    handleDown() {
        if (this.lastIndex >= 0 && this.focusedIndex < this.lastIndex) {
            if (this.focusedIndex < this.lastFileIndex) {
                this.focusedIndex += 1;
                this.onFileFocus.emit(this.focusedIndex);
                return;
            }
            if (this.actionButtonsVisible && this.focusedIndex === this.lastFileIndex) {
                this.focusedIndex += 1;
                this.onActionButtonFocus.emit("clear");
            }
        }
    }
    handleUp() {
        if (this.lastIndex >= 0 && this.focusedIndex > -1) {
            this.focusedIndex -= 1;
            if (this.focusedIndex === -1) {
                this.onSelectButtonFocus.emit();
                return;
            }
            if (this.focusedIndex <= this.lastFileIndex) {
                this.onFileFocus.emit(this.focusedIndex);
                return;
            }
            if (this.actionButtonsVisible && this.focusedIndex <= this.lastIndex) {
                this.focusedIndex = this.lastFileIndex;
                this.onFileFocus.emit(this.focusedIndex);
            }
        }
    }
    get focusedIndex() {
        return this._focusedIndex;
    }
    set focusedIndex(index) {
        if (!this.focused) {
            this.onWrapperFocus.emit();
        }
        this._focusedIndex = index;
        this.focused = true;
        if (this._focusedIndex >= 0 && this._focusedIndex <= this.lastFileIndex) {
            this.onFileFocus.emit(index);
        }
    }
    get lastFileIndex() {
        return this.actionButtonsVisible ? this.lastIndex - 2 : this.lastIndex;
    }
    get lastIndex() {
        const fileCount = this.uploadService.files.count;
        return this.actionButtonsVisible ? fileCount + 1 : fileCount - 1;
    }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(ɵngcc0.ɵɵinject(UploadService)); };
NavigationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NavigationService, factory: NavigationService.ɵfac });
/** @nocollapse */
NavigationService.ctorParameters = () => [
    { type: UploadService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable
    }], function () { return [{ type: UploadService }]; }, null); })();

/**
 * Used to customize the rendering of the files in the list ([see example]({% slug templates_upload %})).
 */
class FileTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
FileTemplateDirective.ɵfac = function FileTemplateDirective_Factory(t) { return new (t || FileTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
FileTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileTemplateDirective, selectors: [["", "kendoUploadFileTemplate", ""], ["", "kendoFileSelectFileTemplate", ""]] });
/** @nocollapse */
FileTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoUploadFileTemplate], [kendoFileSelectFileTemplate]' // tslint:disable-line:directive-selector-prefix
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

let components = {};
/**
 * @hidden
 */
class DropZoneService {
    addComponent(component, zoneId) {
        if (this.has(zoneId)) {
            components[zoneId].push(component);
        }
        else {
            components[zoneId] = [component];
        }
    }
    getComponents(zoneId) {
        return components[zoneId];
    }
    has(id) {
        return id in components;
    }
}
DropZoneService.ɵfac = function DropZoneService_Factory(t) { return new (t || DropZoneService)(); };
DropZoneService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DropZoneService, factory: DropZoneService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropZoneService, [{
        type: Injectable
    }], null, null); })();

/**
 * @hidden
 */
const FILESELECT_VALUE_ACCESSOR = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FileSelectComponent) // tslint:disable-line:no-forward-ref
};
class FileSelectComponent {
    constructor(uploadService, localization, navigation, dropZoneService, ngZone, renderer, cdr, wrapper) {
        this.uploadService = uploadService;
        this.localization = localization;
        this.navigation = navigation;
        this.dropZoneService = dropZoneService;
        this.ngZone = ngZone;
        this.renderer = renderer;
        this.cdr = cdr;
        /**
         * Disables the FileSelect.
         * The default value is `false`.
         */
        this.disabled = false;
        /**
         * Enables the selection of multiple files
         * ([see example]({% slug fileprocessing_upload %}#toc-upload-of-sinlge-or-multiple-files)).
         * If set to `false`, only one file can be selected at a time.
         */
        this.multiple = true;
        /**
         * Toggles the visibility of the file list.
         */
        this.showFileList = true;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the FileSelect.
         */
        this.tabindex = 0;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Fires when the user navigates outside the component.
         */
        this.onBlur = new EventEmitter();
        /**
         * Fires when the component is focused.
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires when files are selected. If prevented, the selected files will not be added to the list.
         */
        this.select = new EventEmitter();
        /**
         * Fires when a file is about to be removed. If prevented, the file will remain in the list.
         */
        this.remove = new EventEmitter();
        /**
         * Fires when the value of the component has changed as a result of a successful `select` or `remove` operation.
         */
        this.valueChange = new EventEmitter();
        this.hostDefaultClasses = true;
        /**
         * @hidden
         */
        this._restrictions = {
            allowedExtensions: [],
            maxFileSize: 0,
            minFileSize: 0
        };
        this.onTouchedCallback = (_) => { };
        this.onChangeCallback = (_) => { };
        this.wrapper = wrapper.nativeElement;
        this.direction = localization.rtl ? 'rtl' : 'ltr';
        this.navigation.computeKeys(this.direction);
        this.fileList = this.uploadService.files;
        this.localizationChangeSubscription = localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
            this.navigation.computeKeys(this.direction);
        });
        this.subscribeBlur();
        this.subscribeFocus();
        this.attachEventHandlers();
        this.setDefaultSettings();
    }
    /**
     * Sets the `name` attribute of the `input` element of the FileSelect.
     */
    set name(name) {
        this.uploadService.async.saveField = name;
    }
    get name() {
        return this.uploadService.async.saveField;
    }
    /**
     * Sets the restrictions for selected files.
     */
    set restrictions(restrictions) {
        let parsedRestrictions = Object.assign({}, this._restrictions, restrictions);
        this._restrictions = parsedRestrictions;
    }
    get restrictions() {
        return this._restrictions;
    }
    get hostDisabledClass() {
        return this.disabled;
    }
    get dir() {
        return this.direction;
    }
    ngOnInit() {
        this.renderer.removeAttribute(this.wrapper, "tabindex");
        if (this.zoneId) {
            this.dropZoneService.addComponent(this, this.zoneId);
        }
    }
    /**
     * @hidden
     */
    textFor(key) {
        return this.localization.get(key);
    }
    /**
     * Focuses the underlying input element.
     */
    focus() {
        setTimeout(() => {
            this.fileSelectButton.nativeElement.focus();
        });
    }
    ngOnDestroy() {
        this.fileList.clear();
        if (this.blurSubscription) {
            this.blurSubscription.unsubscribe();
        }
        if (this.wrapperFocusSubscription) {
            this.wrapperFocusSubscription.unsubscribe();
        }
        if (this.selectButtonFocusSubscription) {
            this.selectButtonFocusSubscription.unsubscribe();
        }
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    handleKeydown(event) {
        if (this.disabled) {
            return;
        }
        if ((event.keyCode === Keys.Enter || event.keyCode === Keys.Space) &&
            event.target === this.fileSelectButton.nativeElement) {
            event.preventDefault();
            this.fileSelect.nativeElement.click();
            return;
        }
        if (hasClasses(event.target, UPLOAD_CLASSES) ||
            (!isFocusable(event.target) && !hasClasses(event.target, IGNORE_TARGET_CLASSES))) {
            this.navigation.process(event);
        }
    }
    /**
     * @hidden
     */
    writeValue(newValue) {
        let isValid = true;
        if (newValue instanceof Array) {
            newValue.forEach((file) => {
                if (!validateInitialFileSelectFile(file)) {
                    isValid = false;
                }
            });
            if (isValid) {
                this.uploadService.addInitialFileSelectFiles(newValue);
            }
        }
        if (newValue === null) {
            this.fileList.clear();
        }
        this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * Removes specific file from the file list.
     */
    removeFileByUid(uid) {
        this.uploadService.removeFiles(uid);
    }
    /**
     * Visually clears all files from the UI.
     */
    clearFiles() {
        this.uploadService.clearFiles();
    }
    /**
     * @hidden
     * Used to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    /**
     * @hidden
     * Used by the external dropzone to add files to the FileSelect
     */
    addFiles(files) {
        this.uploadService.addFiles(files);
    }
    /**
     * @hidden
     */
    get selectButtonTabIndex() {
        return this.disabled ? undefined : this.tabindex;
    }
    /**
     * @hidden
     */
    onFileSelectButtonFocus(_event) {
        this.renderer.addClass(this.fileSelectButton.nativeElement, 'k-state-focused');
        if (!this.navigation.focused) {
            this.navigation.focusedIndex = -1;
        }
    }
    /**
     * @hidden
     */
    onFileSelectButtonBlur(_event) {
        this.renderer.removeClass(this.fileSelectButton.nativeElement, 'k-state-focused');
    }
    subscribeBlur() {
        if (!isDocumentAvailable()) {
            return;
        }
        this.ngZone.runOutsideAngular(() => {
            this.documentClick = fromEvent(document, 'click').pipe(filter((event) => {
                return !(this.wrapper !== event.target && this.wrapper.contains(event.target));
            }));
            this.blurSubscription = merge(this.documentClick, this.navigation.onTab).subscribe(() => {
                if (this.navigation.focused) {
                    this.ngZone.run(() => {
                        this.navigation.focused = false;
                        this.onTouchedCallback();
                        this.onBlur.emit();
                    });
                }
            });
        });
    }
    subscribeFocus() {
        this.wrapperFocusSubscription = this.navigation.onWrapperFocus.subscribe(() => {
            this.onFocus.emit();
        });
        this.selectButtonFocusSubscription = this.navigation.onSelectButtonFocus.subscribe(() => {
            this.fileSelectButton.nativeElement.focus();
        });
    }
    attachEventHandlers() {
        this.subs = this.uploadService.changeEvent.subscribe((files) => {
            let model = [];
            if (files !== null) {
                files.forEach((file) => {
                    if (file.state === FileState.Initial) {
                        model.push(file);
                    }
                    if (file.state === FileState.Selected && file.rawFile && !file.validationErrors) {
                        model.push(file.rawFile);
                    }
                });
            }
            if (model.length === 0) {
                model = null;
            }
            this.onChangeCallback(model);
            this.valueChange.emit(model);
        });
        this.subs.add(this.uploadService.removeEvent.subscribe((args) => {
            this.remove.emit(args);
        }));
        this.subs.add(this.uploadService.selectEvent.subscribe((args) => {
            this.select.emit(args);
        }));
    }
    setDefaultSettings() {
        this.uploadService.async.autoUpload = false;
        this.uploadService.component = 'FileSelect';
    }
}
FileSelectComponent.ɵfac = function FileSelectComponent_Factory(t) { return new (t || FileSelectComponent)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(NavigationService), ɵngcc0.ɵɵdirectiveInject(DropZoneService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FileSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileSelectComponent, selectors: [["kendo-fileselect"]], contentQueries: function FileSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FileTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileTemplate = _t.first);
    } }, viewQuery: function FileSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSelect = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSelectButton = _t.first);
    } }, hostVars: 7, hostBindings: function FileSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function FileSelectComponent_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dir);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostDefaultClasses)("k-upload", ctx.hostDefaultClasses)("k-state-disabled", ctx.hostDisabledClass);
    } }, inputs: { disabled: "disabled", multiple: "multiple", showFileList: "showFileList", tabindex: "tabindex", focusableId: "focusableId", name: "name", restrictions: "restrictions", accept: "accept", zoneId: "zoneId" }, outputs: { onBlur: "blur", onFocus: "focus", select: "select", remove: "remove", valueChange: "valueChange" }, exportAs: ["kendoFileSelect"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            NavigationService,
            UploadService,
            DropZoneService,
            FILESELECT_VALUE_ACCESSOR,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.fileselect'
            },
            {
                provide: KendoInput,
                useExisting: forwardRef(() => FileSelectComponent)
            }
        ])], decls: 12, vars: 14, consts: [["kendoFileSelectLocalizedMessages", "", 6, "dropFilesHere", "invalidFileExtension", "invalidMaxFileSize", "invalidMinFileSize", "remove", "select"], ["kendoFileSelectInternalDropZone", "", 3, "restrictions", "multiple", "disabled"], ["role", "button", 1, "k-button", "k-upload-button", 3, "id", "focus", "blur"], ["fileSelectButton", ""], ["kendoFileSelect", "", 3, "dir", "restrictions", "multiple", "disabled"], ["fileSelect", ""], [1, "k-dropzone-hint"], ["kendo-upload-file-list", "", "class", "k-upload-files k-reset", 3, "disabled", "fileList", "fileTemplate", 4, "ngIf"], ["kendo-upload-file-list", "", 1, "k-upload-files", "k-reset", 3, "disabled", "fileList", "fileTemplate"]], template: function FileSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c14);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function FileSelectComponent_Template_div_focus_3_listener($event) { return ctx.onFileSelectButtonFocus($event); })("blur", function FileSelectComponent_Template_div_blur_3_listener($event) { return ctx.onFileSelectButtonBlur($event); });
        ɵngcc0.ɵɵelement(5, "input", 4, 5);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, FileSelectComponent_ul_11_Template, 1, 3, "ul", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("restrictions", ctx.restrictions)("multiple", ctx.multiple)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.focusableId);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("select"))("tabindex", ctx.selectButtonTabIndex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("dir", ctx.direction)("restrictions", ctx.restrictions)("multiple", ctx.multiple)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("accept", ctx.accept ? ctx.accept : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("select"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dropFilesHere"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFileList && ctx.fileList.count > 0);
    } }, directives: function () { return [LocalizedMessagesDirective, DropZoneInternalDirective, FileSelectDirective, ɵngcc3.NgIf, FileListComponent]; }, encapsulation: 2 });
/** @nocollapse */
FileSelectComponent.ctorParameters = () => [
    { type: UploadService },
    { type: LocalizationService },
    { type: NavigationService },
    { type: DropZoneService },
    { type: NgZone },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
FileSelectComponent.propDecorators = {
    accept: [{ type: Input }],
    disabled: [{ type: Input }],
    multiple: [{ type: Input }],
    name: [{ type: Input }],
    showFileList: [{ type: Input }],
    tabindex: [{ type: Input }],
    restrictions: [{ type: Input }],
    zoneId: [{ type: Input }],
    focusableId: [{ type: Input }],
    fileTemplate: [{ type: ContentChild, args: [FileTemplateDirective,] }],
    fileSelect: [{ type: ViewChild, args: ['fileSelect',] }],
    fileSelectButton: [{ type: ViewChild, args: ['fileSelectButton',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    onFocus: [{ type: Output, args: ['focus',] }],
    select: [{ type: Output }],
    remove: [{ type: Output }],
    valueChange: [{ type: Output }],
    hostDefaultClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-upload',] }],
    hostDisabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }],
    handleKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileSelectComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoFileSelect',
                providers: [
                    LocalizationService,
                    NavigationService,
                    UploadService,
                    DropZoneService,
                    FILESELECT_VALUE_ACCESSOR,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.fileselect'
                    },
                    {
                        provide: KendoInput,
                        useExisting: forwardRef(() => FileSelectComponent)
                    }
                ],
                selector: 'kendo-fileselect',
                template: `
        <ng-container kendoFileSelectLocalizedMessages
            i18n-dropFilesHere="kendo.fileselect.dropFilesHere|The drop zone hint"
            dropFilesHere="Drop files here to select"

            i18n-invalidFileExtension="kendo.fileselect.invalidFileExtension|The text for the invalid allowed extensions restriction message"
            invalidFileExtension="File type not allowed."

            i18n-invalidMaxFileSize="kendo.fileselect.invalidMaxFileSize|The text for the invalid max file size restriction message"
            invalidMaxFileSize="File size too large."

            i18n-invalidMinFileSize="kendo.fileselect.invalidMinFileSize|The text for the invalid min file size restriction message"
            invalidMinFileSize="File size too small."

            i18n-remove="kendo.fileselect.remove|The text for the Remove button"
            remove="Remove"

            i18n-select="kendo.fileselect.select|The text for the Select button"
            select="Select files..."
        >
        </ng-container>
        <div kendoFileSelectInternalDropZone
            [restrictions]="restrictions"
            [multiple]="multiple"
            [disabled]="disabled">
            <div role="button" #fileSelectButton
                [id]="focusableId"
                [attr.aria-label]="textFor('select')"
                [attr.tabindex]="selectButtonTabIndex"
                (focus)="onFileSelectButtonFocus($event)"
                (blur)="onFileSelectButtonBlur($event)"
                class="k-button k-upload-button">
                <input #fileSelect kendoFileSelect
                    [attr.accept]="accept ? accept : null"
                    [dir]="direction"
                    [restrictions]="restrictions"
                    [multiple]="multiple"
                    [disabled]="disabled" />
                <span>{{textFor('select')}}</span>
            </div>
            <div class="k-dropzone-hint">{{textFor('dropFilesHere')}}</div>
        </div>
        <ul kendo-upload-file-list
            class="k-upload-files k-reset"
            *ngIf="showFileList && fileList.count > 0"
            [disabled]="disabled"
            [fileList]="fileList.files"
            [fileTemplate]="fileTemplate">
        </ul>
    `
            }]
    }], function () { return [{ type: UploadService }, { type: ɵngcc2.LocalizationService }, { type: NavigationService }, { type: DropZoneService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { disabled: [{
            type: Input
        }], multiple: [{
            type: Input
        }], showFileList: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], focusableId: [{
            type: Input
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], select: [{
            type: Output
        }], remove: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], hostDefaultClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-upload']
        }], name: [{
            type: Input
        }], restrictions: [{
            type: Input
        }], hostDisabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], 
    /**
     * @hidden
     */
    handleKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], accept: [{
            type: Input
        }], zoneId: [{
            type: Input
        }], fileTemplate: [{
            type: ContentChild,
            args: [FileTemplateDirective]
        }], fileSelect: [{
            type: ViewChild,
            args: ['fileSelect']
        }], fileSelectButton: [{
            type: ViewChild,
            args: ['fileSelectButton']
        }] }); })();

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = function Messages_Factory(t) { return ɵMessages_BaseFactory(t || Messages); };
Messages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { cancel: "cancel", clearSelectedFiles: "clearSelectedFiles", dropFilesHere: "dropFilesHere", externalDropFilesHere: "externalDropFilesHere", filesBatchStatus: "filesBatchStatus", filesBatchStatusFailed: "filesBatchStatusFailed", filesBatchStatusUploaded: "filesBatchStatusUploaded", fileStatusFailed: "fileStatusFailed", fileStatusUploaded: "fileStatusUploaded", headerStatusPaused: "headerStatusPaused", headerStatusUploaded: "headerStatusUploaded", headerStatusUploading: "headerStatusUploading", invalidFileExtension: "invalidFileExtension", invalidMaxFileSize: "invalidMaxFileSize", invalidMinFileSize: "invalidMinFileSize", pause: "pause", remove: "remove", resume: "resume", retry: "retry", select: "select", uploadSelectedFiles: "uploadSelectedFiles" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Messages.propDecorators = {
    cancel: [{ type: Input }],
    clearSelectedFiles: [{ type: Input }],
    dropFilesHere: [{ type: Input }],
    externalDropFilesHere: [{ type: Input }],
    filesBatchStatus: [{ type: Input }],
    filesBatchStatusFailed: [{ type: Input }],
    filesBatchStatusUploaded: [{ type: Input }],
    fileStatusFailed: [{ type: Input }],
    fileStatusUploaded: [{ type: Input }],
    headerStatusPaused: [{ type: Input }],
    headerStatusUploaded: [{ type: Input }],
    headerStatusUploading: [{ type: Input }],
    invalidFileExtension: [{ type: Input }],
    invalidMaxFileSize: [{ type: Input }],
    invalidMinFileSize: [{ type: Input }],
    pause: [{ type: Input }],
    remove: [{ type: Input }],
    resume: [{ type: Input }],
    retry: [{ type: Input }],
    select: [{ type: Input }],
    uploadSelectedFiles: [{ type: Input }]
};
const ɵMessages_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(Messages);

/**
 * Custom component messages override default component messages.
 */
class CustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
CustomMessagesComponent.ɵfac = function CustomMessagesComponent_Factory(t) { return new (t || CustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
CustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CustomMessagesComponent, selectors: [["kendo-upload-messages"], ["kendo-fileselect-messages"], ["kendo-uploaddropzone-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => CustomMessagesComponent) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function CustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
CustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => CustomMessagesComponent) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-upload-messages, kendo-fileselect-messages, kendo-uploaddropzone-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, null); })();

/**
 * @hidden
 */
const INVALIDMAXFILESIZE = "invalidMaxFileSize";
/**
 * @hidden
 */
const INVALIDMINFILESIZE = "invalidMinFileSize";
/**
 * @hidden
 */
const INVALIDFILEEXTENSION = "invalidFileExtension";
const validateFileExtension = (file, allowedExtensions) => {
    if (allowedExtensions.length > 0) {
        if (allowedExtensions.indexOf(file.extension.toLowerCase()) < 0) {
            file.validationErrors = file.validationErrors || [];
            if (file.validationErrors.indexOf(INVALIDFILEEXTENSION) < 0) {
                file.validationErrors.push(INVALIDFILEEXTENSION);
            }
        }
    }
};
const validateFileSize = (file, minFileSize, maxFileSize) => {
    if (minFileSize !== 0 && file.size < minFileSize) {
        file.validationErrors = file.validationErrors || [];
        if (file.validationErrors.indexOf(INVALIDMINFILESIZE) < 0) {
            file.validationErrors.push(INVALIDMINFILESIZE);
        }
    }
    if (maxFileSize !== 0 && file.size > maxFileSize) {
        file.validationErrors = file.validationErrors || [];
        if (file.validationErrors.indexOf(INVALIDMAXFILESIZE) < 0) {
            file.validationErrors.push(INVALIDMAXFILESIZE);
        }
    }
};
const parseAllowedExtensions = (extensions) => {
    const allowedExtensions = extensions.map((ext) => {
        var parsedExt = (ext.substring(0, 1) === ".") ? ext : ("." + ext);
        return parsedExt.toLowerCase();
    });
    return allowedExtensions;
};
/**
 * @hidden
 */
const validateFiles = (files, restrictionInfo) => {
    const allowedExtensions = parseAllowedExtensions(restrictionInfo.allowedExtensions);
    const maxFileSize = restrictionInfo.maxFileSize;
    const minFileSize = restrictionInfo.minFileSize;
    let i;
    for (i = 0; i < files.length; i++) {
        validateFileExtension(files[i], allowedExtensions);
        validateFileSize(files[i], minFileSize, maxFileSize);
    }
};

/**
 * @hidden
 */
class DropZoneBase {
    constructor(element, renderer, hoverClass) {
        this.element = element;
        this.renderer = renderer;
        this.hideIntervalElement = null;
        this.hoverClass = hoverClass;
    }
    /**
     * @hidden
     */
    onElementDragEnterListener() {
        this.addClass(this.hoverClass);
        this.lastDragElement = new Date();
        if (!this.hideIntervalElement) {
            this.hideIntervalElement = setInterval(() => {
                if (this.calculateTimeDiff(this.lastDragElement) < 100) {
                    return;
                }
                this.removeClass(this.hoverClass);
                clearInterval(this.hideIntervalElement);
                this.hideIntervalElement = null;
            }, 100);
        }
        return false;
    }
    /**
     * @hidden
     */
    onElementDragOverListener() {
        this.lastDragElement = new Date();
        return false;
    }
    calculateTimeDiff(prevEvent) {
        return new Date().getTime() - prevEvent.getTime();
    }
    addClass(className) {
        this.renderer.addClass(this.element.nativeElement, className);
    }
    removeClass(className) {
        this.renderer.removeClass(this.element.nativeElement, className);
    }
}
DropZoneBase.ɵfac = function DropZoneBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
DropZoneBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DropZoneBase, hostBindings: function DropZoneBase_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragenter", function DropZoneBase_dragenter_HostBindingHandler() { return ctx.onElementDragEnterListener(); })("dragover", function DropZoneBase_dragover_HostBindingHandler() { return ctx.onElementDragOverListener(); });
    } } });
DropZoneBase.propDecorators = {
    onElementDragEnterListener: [{ type: HostListener, args: ['dragenter',] }],
    onElementDragOverListener: [{ type: HostListener, args: ['dragover',] }]
};


/**
 * @hidden
 */
class DropZoneInternalDirective extends DropZoneBase {
    constructor(element, renderer, ngZone, uploadService) {
        super(element, renderer, 'k-dropzone-hover');
        this.ngZone = ngZone;
        this.uploadService = uploadService;
        this.initialClassName = true;
        this.hideIntervalDocument = null;
        this.activeClass = 'k-dropzone-active';
        this.ngZone.runOutsideAngular(() => {
            this.unsubscribeDocumentDragEnter = this.renderer.listen('document', 'dragenter', () => this.onDocumentDragEnter());
            this.unsubscribeDocumentDragOver = this.renderer.listen('document', 'dragover', () => this.onDocumentDragOver());
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            if (this.unsubscribeDocumentDragEnter) {
                this.unsubscribeDocumentDragEnter();
            }
            if (this.unsubscribeDocumentDragOver) {
                this.unsubscribeDocumentDragOver();
            }
        });
    }
    onDocumentDragEnter() {
        this.addClass(this.activeClass);
        this.lastDragDocument = new Date();
        if (!this.hideIntervalDocument) {
            this.hideIntervalDocument = setInterval(() => {
                if (this.calculateTimeDiff(this.lastDragDocument) < 100) {
                    return;
                }
                this.removeClass(this.activeClass);
                clearInterval(this.hideIntervalDocument);
                this.hideIntervalDocument = null;
            }, 100);
        }
        return false;
    }
    /**
     * @hidden
     */
    onDocumentDragOver() {
        this.lastDragDocument = new Date();
        return false;
    }
    onDropListener(event) {
        let droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0 && !this.disabled) {
            let files = getAllFileInfo(droppedFiles);
            files = assignGuidToFiles(files, !this.uploadService.async.batch);
            if (!this.multiple) {
                files.splice(1, files.length - 1);
                this.uploadService.clearFiles();
            }
            validateFiles(files, this.restrictions);
            this.uploadService.addFiles(files);
        }
        return false;
    }
}
DropZoneInternalDirective.ɵfac = function DropZoneInternalDirective_Factory(t) { return new (t || DropZoneInternalDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(UploadService)); };
DropZoneInternalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DropZoneInternalDirective, selectors: [["", "kendoUploadInternalDropZone", ""], ["", "kendoFileSelectInternalDropZone", ""]], hostVars: 2, hostBindings: function DropZoneInternalDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("drop", function DropZoneInternalDirective_drop_HostBindingHandler($event) { return ctx.onDropListener($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-dropzone", ctx.initialClassName);
    } }, inputs: { disabled: "disabled", multiple: "multiple", restrictions: "restrictions" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
DropZoneInternalDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: NgZone },
    { type: UploadService }
];
DropZoneInternalDirective.propDecorators = {
    disabled: [{ type: Input }],
    multiple: [{ type: Input }],
    restrictions: [{ type: Input }],
    initialClassName: [{ type: HostBinding, args: ['class.k-dropzone',] }],
    onDropListener: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropZoneInternalDirective, [{
        type: Directive,
        args: [{
                selector: `
      [kendoUploadInternalDropZone],
      [kendoFileSelectInternalDropZone]
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: UploadService }]; }, { initialClassName: [{
            type: HostBinding,
            args: ['class.k-dropzone']
        }], onDropListener: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], disabled: [{
            type: Input
        }], multiple: [{
            type: Input
        }], restrictions: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FileListItemDirective {
    constructor(el, navigationService, uploadService) {
        this.navigationService = navigationService;
        this.uploadService = uploadService;
        this.fileClass = true;
        this.focused = false;
        this.element = el;
    }
    focus() {
        this.element.nativeElement.focus();
    }
    get uidAttribute() {
        return this.files[0].uid;
    }
    get tabIndex() {
        return "-1";
    }
    get kFileError() {
        return this.files[0].state === FileState.Failed;
    }
    get kFileInvalid() {
        return filesHaveValidationErrors(this.files);
    }
    get kFileProgress() {
        return this.files[0].state === FileState.Uploading ||
            this.files[0].state === FileState.Paused;
    }
    get kFileSuccess() {
        if (this.uploadService.component === 'Upload') {
            return this.files[0].state === FileState.Uploaded ||
                this.files[0].state === FileState.Initial;
        }
        return false;
    }
    get kStateFocused() {
        return this.focused;
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    onClick(event) {
        if (!isFocusable(event.target) && !hasClasses(event.target, IGNORE_TARGET_CLASSES)) {
            this.navigationService.focusedIndex = this.index;
        }
    }
}
FileListItemDirective.ɵfac = function FileListItemDirective_Factory(t) { return new (t || FileListItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NavigationService), ɵngcc0.ɵɵdirectiveInject(UploadService)); };
FileListItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileListItemDirective, selectors: [["", "kendoUploadFileListItem", ""]], hostVars: 14, hostBindings: function FileListItemDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function FileListItemDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function FileListItemDirective_blur_HostBindingHandler() { return ctx.onBlur(); })("click", function FileListItemDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-uid", ctx.uidAttribute)("tabIndex", ctx.tabIndex);
        ɵngcc0.ɵɵclassProp("k-file", ctx.fileClass)("k-file-error", ctx.kFileError)("k-file-invalid", ctx.kFileInvalid)("k-file-progress", ctx.kFileProgress)("k-file-success", ctx.kFileSuccess)("k-state-focused", ctx.kStateFocused);
    } }, inputs: { files: "files", index: "index" } });
/** @nocollapse */
FileListItemDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NavigationService },
    { type: UploadService }
];
FileListItemDirective.propDecorators = {
    files: [{ type: Input }],
    index: [{ type: Input }],
    fileClass: [{ type: HostBinding, args: ['class.k-file',] }],
    uidAttribute: [{ type: HostBinding, args: ['attr.data-uid',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabIndex',] }],
    kFileError: [{ type: HostBinding, args: ['class.k-file-error',] }],
    kFileInvalid: [{ type: HostBinding, args: ['class.k-file-invalid',] }],
    kFileProgress: [{ type: HostBinding, args: ['class.k-file-progress',] }],
    kFileSuccess: [{ type: HostBinding, args: ['class.k-file-success',] }],
    kStateFocused: [{ type: HostBinding, args: ['class.k-state-focused',] }],
    onFocus: [{ type: HostListener, args: ["focus",] }],
    onBlur: [{ type: HostListener, args: ["blur",] }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileListItemDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoUploadFileListItem]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: NavigationService }, { type: UploadService }]; }, { fileClass: [{
            type: HostBinding,
            args: ['class.k-file']
        }], uidAttribute: [{
            type: HostBinding,
            args: ['attr.data-uid']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], kFileError: [{
            type: HostBinding,
            args: ['class.k-file-error']
        }], kFileInvalid: [{
            type: HostBinding,
            args: ['class.k-file-invalid']
        }], kFileProgress: [{
            type: HostBinding,
            args: ['class.k-file-progress']
        }], kFileSuccess: [{
            type: HostBinding,
            args: ['class.k-file-success']
        }], kStateFocused: [{
            type: HostBinding,
            args: ['class.k-state-focused']
        }], onFocus: [{
            type: HostListener,
            args: ["focus"]
        }], onBlur: [{
            type: HostListener,
            args: ["blur"]
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], files: [{
            type: Input
        }], index: [{
            type: Input
        }] }); })();

/* tslint:disable:component-selector */
/**
 * @hidden
 */
class FileListComponent {
    constructor(uploadService, navigation) {
        this.uploadService = uploadService;
        this.navigation = navigation;
        this.onItemFocus();
        this.onItemAction();
    }
    onItemFocus() {
        this.focusSubscription = this.navigation.onFileFocus.subscribe((index) => {
            this.fileListItems.toArray()[index].focus();
        });
    }
    onItemAction() {
        this.actionSubscription = this.navigation.onFileAction.subscribe((key) => {
            this.itemActionHandler(key);
        });
    }
    itemActionHandler(key) {
        let index = this.navigation.focusedIndex;
        let item = this.fileListItems.toArray()[index];
        let uid = item.uidAttribute;
        let files = this.uploadService.files.get(uid);
        if (key === Keys.Escape && files[0].state === FileState.Uploading) {
            this.uploadService.cancelFiles(uid);
            this.navigation.focusSelectButton();
            return;
        }
        if (key === Keys.Enter && files[0].state === FileState.Failed) {
            this.uploadService.retryFiles(uid);
            return;
        }
        if (key === Keys.Delete) {
            if (files[0].state === FileState.Uploading) {
                this.uploadService.cancelFiles(uid);
            }
            else if (this.hasDelete(item)) {
                this.uploadService.removeFiles(uid);
            }
            this.navigation.focusSelectButton();
        }
    }
    hasDelete(item) {
        return item.element.nativeElement.getElementsByClassName('k-delete').length > 0;
    }
    ngOnDestroy() {
        this.focusSubscription.unsubscribe();
        this.actionSubscription.unsubscribe();
    }
}
FileListComponent.ɵfac = function FileListComponent_Factory(t) { return new (t || FileListComponent)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(NavigationService)); };
FileListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileListComponent, selectors: [["", "kendo-upload-file-list", ""]], viewQuery: function FileListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(FileListItemDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileListItems = _t);
    } }, inputs: { disabled: "disabled", fileList: "fileList", fileTemplate: "fileTemplate" }, attrs: _c15, decls: 1, vars: 1, consts: [["ngFor", "", 3, "ngForOf"], ["kendoUploadFileListItem", "", 3, "files", "index"], ["class", "k-file-single", 3, "disabled", "file", 4, "ngIf"], ["class", "k-file-multiple", 3, "disabled", "files", 4, "ngIf"], [4, "ngIf"], [1, "k-file-single", 3, "disabled", "file"], [1, "k-file-multiple", 3, "disabled", "files"], [3, "templateContext"]], template: function FileListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FileListComponent_ng_template_0_Template, 4, 5, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fileList);
    } }, directives: function () { return [ɵngcc3.NgForOf, FileListItemDirective, ɵngcc3.NgIf, FileListSingleItemComponent, FileListMultipleItemsComponent, TemplateContextDirective]; }, encapsulation: 2 });
/** @nocollapse */
FileListComponent.ctorParameters = () => [
    { type: UploadService },
    { type: NavigationService }
];
FileListComponent.propDecorators = {
    disabled: [{ type: Input }],
    fileList: [{ type: Input }],
    fileTemplate: [{ type: Input }],
    fileListItems: [{ type: ViewChildren, args: [FileListItemDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileListComponent, [{
        type: Component,
        args: [{
                selector: '[kendo-upload-file-list]',
                template: `
    <ng-template ngFor
      [ngForOf]="fileList"
      let-files
      let-index="index">
      <li kendoUploadFileListItem [files]='files' [index]='index'>
          <kendo-upload-file-list-single-item
            class='k-file-single'
            *ngIf='files.length === 1 && !fileTemplate'
            [disabled]='disabled'
            [file]='files[0]'>
          </kendo-upload-file-list-single-item>
          <kendo-upload-file-list-multiple-items
            class='k-file-multiple'
            *ngIf='files.length > 1 && !fileTemplate'
            [disabled]='disabled'
            [files]='files'>
          </kendo-upload-file-list-multiple-items>
          <ng-template *ngIf="fileTemplate"
              [templateContext]="{
                templateRef: fileTemplate.templateRef,
                state: files[0].state,
                $implicit: files
              }"></ng-template>
      </li>
    </ng-template>
    `
            }]
    }], function () { return [{ type: UploadService }, { type: NavigationService }]; }, { disabled: [{
            type: Input
        }], fileList: [{
            type: Input
        }], fileTemplate: [{
            type: Input
        }], fileListItems: [{
            type: ViewChildren,
            args: [FileListItemDirective]
        }] }); })();

/**
 * @hidden
 */
class FileListItemActionButtonComponent {
    constructor(uploadService, localization) {
        this.uploadService = uploadService;
        this.localization = localization;
        this.actionFocused = false;
        this.retryFocused = false;
        this.pauseResumeFocused = false;
    }
    onFocus(type) {
        if (type === 'action') {
            this.actionFocused = true;
        }
        if (type === 'retry') {
            this.retryFocused = true;
        }
        if (type === 'pauseResume') {
            this.pauseResumeFocused = true;
        }
    }
    onBlur(type) {
        if (type === 'retry') {
            this.retryFocused = false;
        }
        if (type === 'action') {
            this.actionFocused = false;
        }
        if (type === 'pauseResume') {
            this.pauseResumeFocused = false;
        }
    }
    onRetryClick() {
        if (this.disabled) {
            return;
        }
        this.uploadService.retryFiles(this.file.uid);
    }
    onRemoveCancelClick() {
        if (this.disabled) {
            return;
        }
        const uid = this.file.uid;
        if (this.file.state === FileState.Uploading) {
            this.uploadService.cancelFiles(uid);
        }
        else {
            this.uploadService.removeFiles(uid);
        }
    }
    onPauseResumeClick() {
        if (this.disabled) {
            return;
        }
        const uid = this.file.uid;
        if (this.file.state === FileState.Paused) {
            this.uploadService.resumeFile(uid);
        }
        else {
            this.uploadService.pauseFile(uid);
        }
    }
    get actionButtonTitle() {
        if (this.file.state === FileState.Uploading) {
            return this.localization.get('cancel');
        }
        return this.localization.get('remove');
    }
    get retryButtonTitle() {
        return this.localization.get('retry');
    }
    get pauseResumeButtonTitle() {
        if (this.file.state === FileState.Uploading) {
            return this.localization.get('pause');
        }
        return this.localization.get('resume');
    }
    get isUploading() {
        return this.file.state === FileState.Uploading;
    }
    get isFailed() {
        return this.file.state === FileState.Failed;
    }
    get isPaused() {
        return this.file.state === FileState.Paused;
    }
    get isResumable() {
        const service = this.uploadService;
        const isResumable = service.async.chunk && service.chunk.resumable;
        const isUploading = (this.file.state === FileState.Paused) || (this.file.state === FileState.Uploading);
        return isResumable && isUploading;
    }
    get isActionButtonVisible() {
        if ((this.file.state === FileState.Uploaded || this.file.state === FileState.Initial) &&
            !this.uploadService.async.removeUrl && this.uploadService.component === 'Upload') {
            return false;
        }
        return true;
    }
}
FileListItemActionButtonComponent.ɵfac = function FileListItemActionButtonComponent_Factory(t) { return new (t || FileListItemActionButtonComponent)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
FileListItemActionButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileListItemActionButtonComponent, selectors: [["kendo-upload-file-list-item-action-button"]], inputs: { file: "file", disabled: "disabled", progress: "progress" }, decls: 5, vars: 4, consts: [[1, "k-upload-status"], ["class", "k-upload-pct", 4, "ngIf"], ["type", "button", "class", "k-button k-button-icon k-flat k-upload-action", 3, "ngClass", "focus", "blur", "click", 4, "ngIf"], [1, "k-upload-pct"], ["type", "button", 1, "k-button", "k-button-icon", "k-flat", "k-upload-action", 3, "ngClass", "focus", "blur", "click"], [1, "k-icon", "k-retry", "k-i-refresh-sm"], [1, "k-icon", 3, "ngClass"]], template: function FileListItemActionButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "strong", 0);
        ɵngcc0.ɵɵtemplate(1, FileListItemActionButtonComponent_span_1_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, FileListItemActionButtonComponent_button_2_Template, 2, 6, "button", 2);
        ɵngcc0.ɵɵtemplate(3, FileListItemActionButtonComponent_button_3_Template, 2, 10, "button", 2);
        ɵngcc0.ɵɵtemplate(4, FileListItemActionButtonComponent_button_4_Template, 2, 10, "button", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isUploading || ctx.isPaused);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFailed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isResumable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActionButtonVisible);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass], encapsulation: 2 });
/** @nocollapse */
FileListItemActionButtonComponent.ctorParameters = () => [
    { type: UploadService },
    { type: LocalizationService }
];
FileListItemActionButtonComponent.propDecorators = {
    file: [{ type: Input }],
    disabled: [{ type: Input }],
    progress: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileListItemActionButtonComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-upload-file-list-item-action-button',
                template: `
      <strong class="k-upload-status">
        <span class="k-upload-pct" *ngIf="isUploading || isPaused">{{progress}}%</span>

        <button type="button" *ngIf="isFailed" class="k-button k-button-icon k-flat k-upload-action"
          [ngClass]="{ 'k-state-focused': this.retryFocused }"
          [attr.tabIndex]="-1"
          (focus)="onFocus('retry')"
          (blur)="onBlur('retry')"
          (click)="onRetryClick()">
          <span class="k-icon k-retry k-i-refresh-sm"
            [attr.aria-label]="retryButtonTitle"
            [attr.title]="retryButtonTitle">
          </span>
        </button>

        <button *ngIf="isResumable" type="button" class="k-button k-button-icon k-flat k-upload-action"
          [ngClass]="{ 'k-state-focused': this.pauseResumeFocused }"
          [attr.tabIndex]="-1"
          (focus)="onFocus('pauseResume')"
          (blur)="onBlur('pauseResume')"
          (click)="onPauseResumeClick()">
          <span class="k-icon"
            [ngClass]="{
              'k-i-play-sm': isPaused,
              'k-i-pause-sm': !isPaused
            }"
            [attr.aria-label]='pauseResumeButtonTitle'
            [attr.title]='pauseResumeButtonTitle'>
          </span>
        </button>

        <button type="button" *ngIf="isActionButtonVisible" class="k-button k-button-icon k-flat k-upload-action"
          [ngClass]="{ 'k-state-focused': this.actionFocused }"
          [attr.tabIndex]="-1"
          (focus)="onFocus('action')"
          (blur)="onBlur('action')"
          (click)="onRemoveCancelClick()">
          <span class="k-icon"
            [ngClass]="{
              'k-i-cancel': isUploading,
              'k-delete k-i-x': !isUploading
            }"
            [attr.aria-label]='actionButtonTitle'
            [attr.title]='actionButtonTitle'>
          </span>
        </button>
      </strong>
    `
            }]
    }], function () { return [{ type: UploadService }, { type: ɵngcc2.LocalizationService }]; }, { file: [{
            type: Input
        }], disabled: [{
            type: Input
        }], progress: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FileListItemBase {
    constructor(uploadService) {
        this.uploadService = uploadService;
        this.progressComplete = 0;
    }
    subscribeUploadProgress(uploadProgressHandler) {
        this.uploadProgressSubscription = this.uploadService.uploadProgressEvent.subscribe(uploadProgressHandler);
    }
    fileHasValidationErrors(file) {
        return fileHasValidationErrors(file);
    }
    filesHaveValidationErrors(files) {
        return filesHaveValidationErrors(files);
    }
    ngOnDestroy() {
        this.uploadProgressSubscription.unsubscribe();
    }
    getFileValidationMessage(file) {
        let validationMessage;
        if (file.validationErrors && file.validationErrors.length > 0) {
            validationMessage = this.localization.get(file.validationErrors[0]);
        }
        return validationMessage;
    }
    getTotalFilesSizeMessage(files) {
        return getTotalFilesSizeMessage(files);
    }
    textFor(key) {
        return this.localization.get(key);
    }
}
FileListItemBase.ɵfac = function FileListItemBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
FileListItemBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileListItemBase });


/**
 * @hidden
 */
class FileListMultipleItemsComponent extends FileListItemBase {
    constructor(localization, uploadService) {
        super(uploadService);
        this.localization = localization;
        this.subscribeUploadProgress((args) => {
            if (args.files[0].uid === this.files[0].uid) {
                this.progressComplete = args.percentComplete;
            }
        });
    }
    get showProgress() {
        const showProgress = this.files[0].state === FileState.Uploading || this.files[0].state === FileState.Paused;
        return showProgress ? 'active' : 'inactive';
    }
    ngOnInit() {
        this.filesHaveErrors = super.filesHaveValidationErrors(this.files);
    }
    fileStatusText(file) {
        const errors = file.validationErrors;
        if (!isPresent(errors)) {
            return this.getTotalFilesSizeMessage([file]);
        }
        return this.getFileValidationMessage(file);
    }
    get batchStatusText() {
        const state$$1 = this.files[0].state;
        const fileCount = this.files.length;
        if (state$$1 === FileState.Uploaded) {
            return `${fileCount} ${this.textFor('filesBatchStatusUploaded')}`;
        }
        if (state$$1 === FileState.Failed) {
            return `${fileCount} ${this.textFor('filesBatchStatusFailed')}`;
        }
        return `${fileCount} ${this.textFor('filesBatchStatus')}`;
    }
    get isUploadSuccessful() {
        return this.files[0].state === FileState.Uploaded;
    }
    get isUploadFailed() {
        return this.files[0].state === FileState.Failed;
    }
}
FileListMultipleItemsComponent.ɵfac = function FileListMultipleItemsComponent_Factory(t) { return new (t || FileListMultipleItemsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(UploadService)); };
FileListMultipleItemsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileListMultipleItemsComponent, selectors: [["kendo-upload-file-list-multiple-items"]], inputs: { disabled: "disabled", files: "files" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 12, consts: [[1, "k-progressbar"], [1, "k-progress"], [1, "k-multiple-files-group-wrapper"], [1, "k-file-group", "k-icon", "k-i-copy"], [1, "k-multiple-files-wrapper"], ["class", "k-file-name-size-wrapper", 4, "ngFor", "ngForOf"], [1, "k-file-information", 3, "ngClass"], [3, "file", "disabled", "progress"], [1, "k-file-name-size-wrapper"], [1, "k-file-name", 3, "title"], [3, "ngClass"]], template: function FileListMultipleItemsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtemplate(5, FileListMultipleItemsComponent_span_5_Template, 5, 8, "span", 5);
        ɵngcc0.ɵɵelementStart(6, "span", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "kendo-upload-file-list-item-action-button", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@progressState", ctx.showProgress);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.progressComplete + "%");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.files);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c21, ctx.isUploadSuccessful, ctx.isUploadFailed));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.batchStatusText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("file", ctx.files[0])("disabled", ctx.disabled)("progress", ctx.progressComplete);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass, FileListItemActionButtonComponent], encapsulation: 2, data: { animation: [
            trigger('progressState', [
                state('active', style({ opacity: 1 })),
                state('inactive', style({ opacity: 0 })),
                transition('void => active', style({ opacity: 0 })),
                transition('inactive => active', style({ opacity: 1 })),
                transition('active => inactive', animate('1s 2s ease-out'))
            ])
        ] } });
/** @nocollapse */
FileListMultipleItemsComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: UploadService }
];
FileListMultipleItemsComponent.propDecorators = {
    disabled: [{ type: Input }],
    files: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileListMultipleItemsComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('progressState', [
                        state('active', style({ opacity: 1 })),
                        state('inactive', style({ opacity: 0 })),
                        transition('void => active', style({ opacity: 0 })),
                        transition('inactive => active', style({ opacity: 1 })),
                        transition('active => inactive', animate('1s 2s ease-out'))
                    ])
                ],
                selector: 'kendo-upload-file-list-multiple-items',
                template: `
      <div class="k-progressbar" [@progressState]="showProgress">
        <span class="k-progress" [style.width]="progressComplete + '%'"></span>
      </div>
      <span class="k-multiple-files-group-wrapper">
        <span class="k-file-group k-icon k-i-copy"></span>
      </span>
      <span class="k-multiple-files-wrapper">
        <span *ngFor="let file of files" class="k-file-name-size-wrapper">
            <span [title]="file.name" class="k-file-name">
                {{file.name}}
            </span>
            <span [ngClass]="{
                    'k-text-error': file.validationErrors,
                    'k-file-validation-message': file.validationErrors,
                    'k-file-size': !file.validationErrors
                  }"
            >{{fileStatusText(file)}}</span>
        </span>
        <span class="k-file-information"
          [ngClass]="{
            'k-text-success': isUploadSuccessful,
            'k-text-error': isUploadFailed
          }"
        >{{batchStatusText}}</span>
      </span>
      <kendo-upload-file-list-item-action-button
        [file]='files[0]'
        [disabled]='disabled'
        [progress]='progressComplete'>
      </kendo-upload-file-list-item-action-button>
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }, { type: UploadService }]; }, { disabled: [{
            type: Input
        }], files: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FileListSingleItemComponent extends FileListItemBase {
    constructor(localization, uploadService) {
        super(uploadService);
        this.localization = localization;
        this.subscribeUploadProgress((args) => {
            if (args.files[0].uid === this.file.uid) {
                this.progressComplete = args.percentComplete;
            }
        });
    }
    get fileStatusText() {
        const errors = this.file.validationErrors;
        if (this.file.state === FileState.Uploaded) {
            return `${this.textFor('fileStatusUploaded')}`;
        }
        if (this.file.state === FileState.Failed) {
            return `${this.textFor('fileStatusFailed')}`;
        }
        if (!isPresent(errors)) {
            return this.getTotalFilesSizeMessage([this.file]);
        }
        return this.getFileValidationMessage(this.file);
    }
    get showProgress() {
        const showProgress = this.file.state === FileState.Uploading || this.file.state === FileState.Paused;
        return showProgress ? 'active' : 'inactive';
    }
    get fileGroupClass() {
        return getFileGroupCssClass(this.file.extension ? this.file.extension : '');
    }
    get isUploadSuccessful() {
        return this.file.state === FileState.Uploaded;
    }
    get isUploadFailed() {
        return this.file.state === FileState.Failed;
    }
    get isNotYetUploaded() {
        return !this.isUploadFailed && !this.isUploadSuccessful;
    }
}
FileListSingleItemComponent.ɵfac = function FileListSingleItemComponent_Factory(t) { return new (t || FileListSingleItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(UploadService)); };
FileListSingleItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileListSingleItemComponent, selectors: [["kendo-upload-file-list-single-item"]], inputs: { disabled: "disabled", file: "file" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 17, consts: [[1, "k-progressbar"], [1, "k-progress"], [1, "k-file-group-wrapper"], [1, "k-file-group", "k-icon", 3, "ngClass"], [1, "k-file-name-size-wrapper"], [1, "k-file-name", 3, "title"], [3, "ngClass"], [3, "file", "disabled", "progress"]], template: function FileListSingleItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "kendo-upload-file-list-item-action-button", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@progressState", ctx.showProgress);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.progressComplete + "%");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.fileGroupClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ctx.file.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.file.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(11, _c22, ctx.file.validationErrors, !ctx.file.validationErrors && ctx.isNotYetUploaded, ctx.isUploadSuccessful, ctx.file.validationErrors || ctx.isUploadFailed, ctx.isUploadSuccessful || ctx.isUploadFailed));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.fileStatusText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("file", ctx.file)("disabled", ctx.disabled)("progress", ctx.progressComplete);
    } }, directives: [ɵngcc3.NgClass, FileListItemActionButtonComponent], encapsulation: 2, data: { animation: [
            trigger('progressState', [
                state('active', style({ opacity: 1 })),
                state('inactive', style({ opacity: 0 })),
                transition('void => active', style({ opacity: 0 })),
                transition('inactive => active', style({ opacity: 1 })),
                transition('active => inactive', animate('1s 2s ease-out'))
            ])
        ] } });
/** @nocollapse */
FileListSingleItemComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: UploadService }
];
FileListSingleItemComponent.propDecorators = {
    disabled: [{ type: Input }],
    file: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileListSingleItemComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('progressState', [
                        state('active', style({ opacity: 1 })),
                        state('inactive', style({ opacity: 0 })),
                        transition('void => active', style({ opacity: 0 })),
                        transition('inactive => active', style({ opacity: 1 })),
                        transition('active => inactive', animate('1s 2s ease-out'))
                    ])
                ],
                selector: 'kendo-upload-file-list-single-item',
                template: `
      <div class="k-progressbar" [@progressState]="showProgress">
        <span class="k-progress" [style.width]="progressComplete + '%'"></span>
      </div>
      <span class="k-file-group-wrapper">
        <span class="k-file-group k-icon" [ngClass]="fileGroupClass"></span>
      </span>
      <span class="k-file-name-size-wrapper">
        <span class="k-file-name" [title]="file.name">{{ file.name }}</span>
        <span [ngClass]="{
                'k-file-validation-message': file.validationErrors,
                'k-file-size': !file.validationErrors && isNotYetUploaded,
                'k-text-success': isUploadSuccessful,
                'k-text-error': file.validationErrors || isUploadFailed,
                'k-file-information': isUploadSuccessful || isUploadFailed
              }"
        >{{fileStatusText}}</span>
      </span>
      <kendo-upload-file-list-item-action-button
        [file]='file'
        [disabled]='disabled'
        [progress]='progressComplete'>
      </kendo-upload-file-list-item-action-button>
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }, { type: UploadService }]; }, { disabled: [{
            type: Input
        }], file: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class FileSelectDirective {
    constructor(uploadService, navigation, el) {
        this.uploadService = uploadService;
        this.navigation = navigation;
        this.type = "file";
        this.autocomplete = "off";
        this.tabIndex = -1;
        this.element = el;
    }
    get nameAttribute() {
        return this.uploadService.async.saveField;
    }
    get multipleAttribute() {
        return this.multiple ? "multiple" : null;
    }
    get dirAttribute() {
        return this.dir;
    }
    get disabledAttribute() {
        return this.disabled ? "true" : null;
    }
    onInputChange(event) {
        const ua = navigator.userAgent;
        const chrome = /(chrome)[ \/]([\w.]+)/i;
        const safari = /(webkit)[ \/]([\w.]+)/i;
        let selectedFiles = inputFiles(event.target);
        selectedFiles = assignGuidToFiles(selectedFiles, !this.uploadService.async.batch);
        validateFiles(selectedFiles, this.restrictions);
        if (!this.multiple) {
            this.uploadService.clearFiles();
        }
        this.uploadService.addFiles(selectedFiles);
        /*
        Chrome and Internet Explorer do not trigger a `change` event
        when a file with the same name is selected a number of consecutive times.
        As a workaround, clear the input value after handling the file.
        */
        const native = this.element.nativeElement;
        if (!(!ua.match(chrome) && ua.match(safari))) {
            native.type = "";
            native.type = "file";
        }
        setTimeout(() => {
            this.navigation.focusedIndex = -1;
        });
    }
}
FileSelectDirective.ɵfac = function FileSelectDirective_Factory(t) { return new (t || FileSelectDirective)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(NavigationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FileSelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileSelectDirective, selectors: [["", "kendoFileSelect", ""]], hostVars: 7, hostBindings: function FileSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function FileSelectDirective_change_HostBindingHandler($event) { return ctx.onInputChange($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("type", ctx.type)("autocomplete", ctx.autocomplete)("tabindex", ctx.tabIndex)("name", ctx.nameAttribute)("multiple", ctx.multipleAttribute)("dir", ctx.dirAttribute)("disabled", ctx.disabledAttribute);
    } }, inputs: { dir: "dir", disabled: "disabled", multiple: "multiple", restrictions: "restrictions" } });
/** @nocollapse */
FileSelectDirective.ctorParameters = () => [
    { type: UploadService },
    { type: NavigationService },
    { type: ElementRef }
];
FileSelectDirective.propDecorators = {
    dir: [{ type: Input }],
    disabled: [{ type: Input }],
    multiple: [{ type: Input }],
    restrictions: [{ type: Input }],
    type: [{ type: HostBinding, args: ["attr.type",] }],
    autocomplete: [{ type: HostBinding, args: ["attr.autocomplete",] }],
    tabIndex: [{ type: HostBinding, args: ["attr.tabindex",] }],
    nameAttribute: [{ type: HostBinding, args: ["attr.name",] }],
    multipleAttribute: [{ type: HostBinding, args: ["attr.multiple",] }],
    dirAttribute: [{ type: HostBinding, args: ["attr.dir",] }],
    disabledAttribute: [{ type: HostBinding, args: ["attr.disabled",] }],
    onInputChange: [{ type: HostListener, args: ["change", ["$event"],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoFileSelect]'
            }]
    }], function () { return [{ type: UploadService }, { type: NavigationService }, { type: ɵngcc0.ElementRef }]; }, { type: [{
            type: HostBinding,
            args: ["attr.type"]
        }], autocomplete: [{
            type: HostBinding,
            args: ["attr.autocomplete"]
        }], tabIndex: [{
            type: HostBinding,
            args: ["attr.tabindex"]
        }], nameAttribute: [{
            type: HostBinding,
            args: ["attr.name"]
        }], multipleAttribute: [{
            type: HostBinding,
            args: ["attr.multiple"]
        }], dirAttribute: [{
            type: HostBinding,
            args: ["attr.dir"]
        }], disabledAttribute: [{
            type: HostBinding,
            args: ["attr.disabled"]
        }], onInputChange: [{
            type: HostListener,
            args: ["change", ["$event"]]
        }], dir: [{
            type: Input
        }], disabled: [{
            type: Input
        }], multiple: [{
            type: Input
        }], restrictions: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class LocalizedMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoUploadLocalizedMessages", ""], ["", "kendoFileSelectLocalizedMessages", ""], ["", "kendoUploadDropZoneLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => LocalizedMessagesDirective) // tslint:disable-line:no-forward-ref
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => LocalizedMessagesDirective) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: `
    [kendoUploadLocalizedMessages],
    [kendoFileSelectLocalizedMessages],
    [kendoUploadDropZoneLocalizedMessages]
  `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, null); })();

/**
 * @hidden
 */
class TemplateContextDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    set templateContext(context) {
        if (this.insertedViewRef) {
            this.viewContainerRef.remove(this.viewContainerRef.indexOf(this.insertedViewRef));
            this.insertedViewRef = undefined;
        }
        if (context.templateRef) {
            this.insertedViewRef = this.viewContainerRef.createEmbeddedView(context.templateRef, context);
        }
    }
}
TemplateContextDirective.ɵfac = function TemplateContextDirective_Factory(t) { return new (t || TemplateContextDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
TemplateContextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TemplateContextDirective, selectors: [["", "templateContext", ""]], inputs: { templateContext: "templateContext" } });
/** @nocollapse */
TemplateContextDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
TemplateContextDirective.propDecorators = {
    templateContext: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TemplateContextDirective, [{
        type: Directive,
        args: [{
                selector: '[templateContext]' // tslint:disable-line:directive-selector
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { templateContext: [{
            type: Input
        }] }); })();

/* tslint:disable: no-use-before-declare */
/**
 * @hidden
 */
const UPLOAD_VALUE_ACCESSOR = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UploadComponent) // tslint:disable-line:no-forward-ref
};
/**
 * Represents the [Kendo UI Upload component for Angular]({% slug overview_upload %}).
 */
class UploadComponent {
    constructor(uploadService, localization, navigation, dropZoneService, _ngZone, renderer, cdr, wrapper) {
        this.uploadService = uploadService;
        this.localization = localization;
        this.navigation = navigation;
        this.dropZoneService = dropZoneService;
        this._ngZone = _ngZone;
        this.renderer = renderer;
        this.cdr = cdr;
        /**
         * Enables the chunk functionality of the Upload.
         *
         * The default value is `false`.
         */
        this.chunkable = false;
        /**
         * Enables the selection of multiple files
         * ([see example]({% slug fileprocessing_upload %}#toc-upload-of-sinlge-or-multiple-files)).
         * If set to `false`, only one file can be selected at a time.
         */
        this.multiple = true;
        /**
         * Disables the Upload ([see example]({% slug disabledstate_upload %})).
         * The default value is `false`.
         */
        this.disabled = false;
        /**
         * Toggles the visibility of the file list.
         */
        this.showFileList = true;
        /**
         * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
         */
        this.tabindex = 0;
        /**
         * @hidden
         */
        this.focusableId = `k-${guid()}`;
        /**
         * Fires when the user navigates outside the component.
         */
        this.onBlur = new EventEmitter();
        /**
         * Fires when the upload is canceled while in progress.
         */
        this.cancel = new EventEmitter();
        /**
         * Fires when the file list is about to be cleared. If prevented, the files will not be cleared.
         */
        this.clear = new EventEmitter();
        /**
         * Fires when all active uploads are completed either successfully or with errors.
         */
        this.complete = new EventEmitter();
        /**
         * Fires when an `upload` or `remove` operation has failed.
         */
        this.error = new EventEmitter();
        /**
         * Fires when the component is focused.
         */
        this.onFocus = new EventEmitter();
        /**
         * Fires when the upload of a file has been paused.
         */
        this.pause = new EventEmitter();
        /**
         * Fires when an uploaded file is about to be removed. If prevented, the files will remain in the list.
         */
        this.remove = new EventEmitter();
        /**
         * Fires when the upload of a file has been resumed.
         */
        this.resume = new EventEmitter();
        /**
         * Fires when files are selected. If prevented, the selected files will not be added to the list.
         */
        this.select = new EventEmitter();
        /**
         * Fires when an `upload` or `remove` operation is successfully completed.
         */
        this.success = new EventEmitter();
        /**
         * Fires when one or more files are about to be uploaded. If prevented, the files will neither be uploaded, nor added to the file list.
         */
        this.upload = new EventEmitter();
        /**
         * Fires when one or more files are being uploaded.
         */
        this.uploadProgress = new EventEmitter();
        /**
         * Fires when the value of the component has changed as a result of a successful `upload`, `remove` or `clear` operation.
         */
        this.valueChange = new EventEmitter();
        this.hostDefaultClasses = true;
        /**
         * @hidden
         */
        this._restrictions = {
            allowedExtensions: [],
            maxFileSize: 0,
            minFileSize: 0
        };
        this.onTouchedCallback = (_) => { };
        this.onChangeCallback = (_) => { };
        this.fileList = this.uploadService.files;
        this.localizationChangeSubscription = localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
            this.navigation.computeKeys(this.direction);
        });
        this.direction = localization.rtl ? 'rtl' : 'ltr';
        this.navigation.computeKeys(this.direction);
        this.wrapper = wrapper.nativeElement;
        this.subscribeBlur();
        this.subscribeFocus();
        this.attachEventHandlers();
    }
    /**
     * By default, the selected files are immediately uploaded
     * ([see example]({% slug fileprocessing_upload %}#toc-automatic-upload-of-files)).
     * To change this behavior, set `autoUpload` to `false`.
     */
    set autoUpload(autoUpload) {
        this.uploadService.async.autoUpload = autoUpload;
    }
    get autoUpload() {
        return this.uploadService.async.autoUpload;
    }
    /**
     * When enabled, all files in the selection are uploaded in one request
     * ([see example]({% slug fileprocessing_upload %}#toc-upload-of-batches-of-files)).
     * Any files that are selected one after the other are uploaded in separate requests.
     */
    set batch(batch) {
        this.uploadService.async.batch = batch;
    }
    get batch() {
        return this.uploadService.async.batch;
    }
    /**
     * Configures whether credentials (cookies, headers) will be sent for cross-site requests
     * ([see example]({% slug credentials_upload %}#toc-attaching-credentials-to-requests)).
     * The default values is `true`. Setting `withCredentials` has no effect on same-site requests.
     * To add credentials to the request, use the `saveHeaders` or `removeHeaders` property,
     * or the [`upload`]({% slug api_upload_uploadevent %}) event.
     */
    set withCredentials(withCredentials) {
        this.uploadService.async.withCredentials = withCredentials;
    }
    get withCredentials() {
        return this.uploadService.async.withCredentials;
    }
    /**
     * Sets the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) key which contains the files submitted to `saveUrl`.
     * The default value is `files`.
     */
    set saveField(saveField) {
        this.uploadService.async.saveField = saveField;
    }
    get saveField() {
        return this.uploadService.async.saveField;
    }
    /**
     * Configures the [`HttpHeaders`](https://angular.io/api/common/http/HttpHeaders)
     * that are attached to each upload request.
     */
    set saveHeaders(saveHeaders) {
        this.uploadService.async.saveHeaders = saveHeaders;
    }
    get saveHeaders() {
        return this.uploadService.async.saveHeaders;
    }
    /**
     * Sets the [`RequestMethod`](https://angular.io/api/http/RequestMethod) of the upload request.
     * The default value is `POST`.
     */
    set saveMethod(saveMethod) {
        this.uploadService.async.saveMethod = saveMethod;
    }
    get saveMethod() {
        return this.uploadService.async.saveMethod;
    }
    /**
     * Sets the URL of the endpoint for the upload request.
     * The request [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) key is named after the `saveField` property.
     * It contains the list of files to be uploaded.
     */
    set saveUrl(saveUrl) {
        this.uploadService.async.saveUrl = saveUrl;
    }
    get saveUrl() {
        return this.uploadService.async.saveUrl;
    }
    /**
     * Sets the expected [`response type`](https://angular.io/api/common/http/HttpRequest#responseType) of the server.
     * It is used to parse the response appropriately.
     * The default value is `json`.
     */
    set responseType(responseType) {
        this.uploadService.async.responseType = responseType;
    }
    get responseType() {
        return this.uploadService.async.responseType;
    }
    /**
     * Sets the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) key
     * which contains the list of file names that are submitted to `removeUrl`.
     * The default value is `fileNames`.
     */
    set removeField(removeField) { this.uploadService.async.removeField = removeField; }
    get removeField() { return this.uploadService.async.removeField; }
    /**
     * Configures the [`HttpHeaders`](https://angular.io/api/common/http/HttpHeaders)
     * that are attached to each `remove` request.
     */
    set removeHeaders(removeHeaders) {
        this.uploadService.async.removeHeaders = removeHeaders;
    }
    get removeHeaders() {
        return this.uploadService.async.removeHeaders;
    }
    /**
     * Sets the [`RequestMethod`](https://angular.io/api/http/RequestMethod) of the `remove` request.
     * The default value is `POST`.
     */
    set removeMethod(removeMethod) {
        this.uploadService.async.removeMethod = removeMethod;
    }
    get removeMethod() {
        return this.uploadService.async.removeMethod;
    }
    /**
     * Sets the URL of the endpoint for the `remove` request.
     * The [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) request key is named after the `removeField` property.
     * It contains the list of file names which will be removed.
     */
    set removeUrl(removeUrl) {
        this.uploadService.async.removeUrl = removeUrl;
    }
    get removeUrl() {
        return this.uploadService.async.removeUrl;
    }
    /**
     * Specifies if the selected files are uploaded simultaneously or one by one.
     *
     * The default value is `true`.
     */
    set concurrent(concurrent) {
        this.uploadService.async.concurrent = concurrent;
    }
    get concurrent() {
        return this.uploadService.async.concurrent;
    }
    /**
     * @hidden
     */
    set tabIndex(tabIndex) {
        this.tabindex = tabIndex;
    }
    get tabIndex() {
        return this.tabindex;
    }
    /**
     * Sets the restrictions for selected files ([see example]({% slug api_upload_filerestrictions %})).
     */
    set restrictions(restrictions) {
        let parsedRestrictions = Object.assign({}, this._restrictions, restrictions);
        this._restrictions = parsedRestrictions;
    }
    get restrictions() {
        return this._restrictions;
    }
    get hostDisabledClass() {
        return this.disabled;
    }
    get dir() {
        return this.direction;
    }
    ngOnInit() {
        this.verifySettings();
        this.renderer.removeAttribute(this.wrapper, "tabindex");
        this.uploadService.setChunkSettings(this.chunkable);
        if (this.zoneId) {
            this.dropZoneService.addComponent(this, this.zoneId);
        }
    }
    ngOnChanges(changes) {
        if (isChanged("chunkable", changes)) {
            const newChunkable = changes.chunkable.currentValue;
            if (typeof newChunkable === 'boolean') {
                this.uploadService.async.chunk = newChunkable;
            }
            if (typeof newChunkable === "object" && newChunkable !== null) {
                this.uploadService.async.chunk = true;
                this.uploadService.chunk = Object.assign({}, this.uploadService.chunk, newChunkable);
            }
        }
    }
    ngOnDestroy() {
        this.fileList.clear();
        if (this.blurSubscription) {
            this.blurSubscription.unsubscribe();
        }
        if (this.wrapperFocusSubscription) {
            this.wrapperFocusSubscription.unsubscribe();
        }
        if (this.selectButtonFocusSubscription) {
            this.selectButtonFocusSubscription.unsubscribe();
        }
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    handleKeydown(event) {
        if (this.disabled) {
            return;
        }
        if ((event.keyCode === Keys.Enter || event.keyCode === Keys.Space) &&
            event.target === this.fileSelectButton.nativeElement) {
            event.preventDefault();
            this.fileSelect.nativeElement.click();
            return;
        }
        if (hasClasses(event.target, UPLOAD_CLASSES) ||
            (!isFocusable(event.target) && !hasClasses(event.target, IGNORE_TARGET_CLASSES))) {
            this.navigation.process(event);
        }
    }
    /**
     * @hidden
     */
    writeValue(newValue) {
        let isValid = true;
        if (newValue instanceof Array) {
            newValue.forEach((file) => {
                if (!validateInitialFileInfo(file)) {
                    isValid = false;
                }
            });
            if (isValid) {
                this.uploadService.addInitialFiles(newValue);
            }
        }
        if (newValue === null) {
            this.fileList.clear();
        }
        this.cdr.markForCheck();
    }
    /**
     * @hidden
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * @hidden
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /**
     * @hidden
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @hidden
     */
    get selectButtonTabIndex() {
        return this.disabled ? undefined : this.tabIndex;
    }
    /**
     * @hidden
     */
    onFileSelectButtonFocus(_event) {
        this.renderer.addClass(this.fileSelectButton.nativeElement, 'k-state-focused');
        if (!this.navigation.focused) {
            this.navigation.focusedIndex = -1;
        }
    }
    /**
     * @hidden
     */
    onFileSelectButtonBlur(_event) {
        this.renderer.removeClass(this.fileSelectButton.nativeElement, 'k-state-focused');
    }
    /**
     * @hidden
     */
    get showActionButtons() {
        let areVisible = false;
        if (!this.autoUpload) {
            const hasFilesToUpload = this.fileList.filesToUpload.length > 0;
            const uploadingFiles = this.fileList.hasFileWithState([FileState.Uploading]);
            if (this.concurrent && hasFilesToUpload) {
                areVisible = true;
            }
            if (!this.concurrent && hasFilesToUpload && !uploadingFiles) {
                areVisible = true;
            }
        }
        this.navigation.actionButtonsVisible = areVisible;
        return areVisible;
    }
    /**
     * @hidden
     */
    get showTotalStatus() {
        const states = [
            FileState.Uploaded,
            FileState.Uploading,
            FileState.Failed,
            FileState.Paused
        ];
        if (this.fileList.hasFileWithState(states)) {
            return true;
        }
        return false;
    }
    /**
     * @hidden
     */
    textFor(key) {
        return this.localization.get(key);
    }
    /**
     * Focuses the underlying input element.
     */
    focus() {
        setTimeout(() => {
            this.fileSelectButton.nativeElement.focus();
        });
    }
    /**
     * @hidden
     * @deprecated
     */
    focusComponent() {
        this.focus();
    }
    /**
     * Blurs the Upload if it was previously focused.
     */
    blur() {
        if (this.navigation.focused) {
            this.navigation.focused = false;
            document.activeElement.blur();
            this.onBlur.emit();
        }
    }
    /**
     * @hidden
     * @deprecated
     */
    blurComponent() {
        this.blur();
    }
    /**
     * Pauses the upload process of a file that is currently uploading.
     * The `pauseFileByUid` method requires the `chunkable` option of the Upload to be enabled.
     *
     * @param uid - The `uid` of the file that will be paused.
     */
    pauseFileByUid(uid) {
        this.uploadService.pauseFile(uid);
    }
    /**
     * Resumes the upload process for a file that has been previously paused.
     * The `resumeFileByUid` method requires the `chunkable` option of the Upload to be enabled.
     *
     * @param uid - The `uid` of the file that will be resumed.
     */
    resumeFileByUid(uid) {
        this.uploadService.resumeFile(uid);
    }
    /**
     * Triggers the removal of a file or a batch of files.
     * @param uid - The `uid` of the file or a batch of files that will be removed.
     */
    removeFilesByUid(uid) {
        this.uploadService.removeFiles(uid);
    }
    /**
     * Triggers another upload attempt of an unsuccessfully uploaded file or a batch of files.
     * @param uid - The `uid` of the file or a batch of files to be retried.
     */
    retryUploadByUid(uid) {
        this.uploadService.retryFiles(uid);
    }
    /**
     * Cancels the upload of a file or a batch of files.
     * @param uid - The `uid` of the file or a batch of files that will be canceled.
     */
    cancelUploadByUid(uid) {
        this.uploadService.cancelFiles(uid);
    }
    /**
     * Uploads the currently selected files which pass the set restrictions.
     */
    uploadFiles() {
        if (this.fileList.filesToUpload.length) {
            this.uploadService.uploadFiles();
        }
    }
    /**
     * Visually clears all files from the UI without issuing requests to the remove handler.
     */
    clearFiles() {
        this.uploadService.clearFiles();
    }
    /**
     * @hidden
     * Used by the external dropzone to add files to the Upload
     */
    addFiles(files) {
        this.uploadService.addFiles(files);
    }
    /**
     * @hidden
     * Used to determine if the component is empty.
     */
    isEmpty() {
        return false;
    }
    verifySettings() {
        if (isDevMode()) {
            if (this.batch && this.chunkable !== false) {
                throw new Error('The file chunking functionality requires the batch setting to be disabled.');
            }
        }
    }
    subscribeBlur() {
        if (!isDocumentAvailable()) {
            return;
        }
        this._ngZone.runOutsideAngular(() => {
            this.documentClick = fromEvent(document, 'click').pipe(filter((event) => {
                return !(this.wrapper !== event.target && this.wrapper.contains(event.target));
            }));
            this.blurSubscription = merge(this.documentClick, this.navigation.onTab).subscribe(() => {
                if (this.navigation.focused) {
                    this._ngZone.run(() => {
                        this.navigation.focused = false;
                        this.onTouchedCallback();
                        this.onBlur.emit();
                    });
                }
            });
        });
    }
    subscribeFocus() {
        this.wrapperFocusSubscription = this.navigation.onWrapperFocus.subscribe(() => {
            this.onFocus.emit();
        });
        this.selectButtonFocusSubscription = this.navigation.onSelectButtonFocus.subscribe(() => {
            this.fileSelectButton.nativeElement.focus();
        });
    }
    attachEventHandlers() {
        this.subs = this.uploadService.cancelEvent.subscribe((args) => {
            this.cancel.emit(args);
        });
        this.subs.add(this.uploadService.changeEvent.subscribe((files) => {
            this.onChangeCallback(files);
            this.valueChange.emit(files);
        }));
        this.subs.add(this.uploadService.clearEvent.subscribe((args) => {
            this.clear.emit(args);
        }));
        this.subs.add(this.uploadService.completeEvent.subscribe(() => {
            this.complete.emit();
        }));
        this.subs.add(this.uploadService.errorEvent.subscribe((args) => {
            this.error.emit(args);
        }));
        this.subs.add(this.uploadService.pauseEvent.subscribe((args) => {
            this.pause.emit(args);
        }));
        this.subs.add(this.uploadService.removeEvent.subscribe((args) => {
            this.remove.emit(args);
        }));
        this.subs.add(this.uploadService.resumeEvent.subscribe((args) => {
            this.resume.emit(args);
        }));
        this.subs.add(this.uploadService.selectEvent.subscribe((args) => {
            this.select.emit(args);
        }));
        this.subs.add(this.uploadService.successEvent.subscribe((args) => {
            this.success.emit(args);
        }));
        this.subs.add(this.uploadService.uploadEvent.subscribe((args) => {
            this.upload.emit(args);
        }));
        this.subs.add(this.uploadService.uploadProgressEvent.subscribe((args) => {
            this.uploadProgress.emit(args);
        }));
    }
}
UploadComponent.ɵfac = function UploadComponent_Factory(t) { return new (t || UploadComponent)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(NavigationService), ɵngcc0.ɵɵdirectiveInject(DropZoneService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
UploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadComponent, selectors: [["kendo-upload"]], contentQueries: function UploadComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, FileTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileTemplate = _t.first);
    } }, viewQuery: function UploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSelect = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSelectButton = _t.first);
    } }, hostVars: 7, hostBindings: function UploadComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function UploadComponent_keydown_HostBindingHandler($event) { return ctx.handleKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dir);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostDefaultClasses)("k-upload", ctx.hostDefaultClasses)("k-state-disabled", ctx.hostDisabledClass);
    } }, inputs: { chunkable: "chunkable", multiple: "multiple", disabled: "disabled", showFileList: "showFileList", tabindex: "tabindex", focusableId: "focusableId", autoUpload: "autoUpload", batch: "batch", withCredentials: "withCredentials", saveField: "saveField", saveHeaders: "saveHeaders", saveMethod: "saveMethod", saveUrl: "saveUrl", responseType: "responseType", removeField: "removeField", removeHeaders: "removeHeaders", removeMethod: "removeMethod", removeUrl: "removeUrl", concurrent: "concurrent", tabIndex: "tabIndex", restrictions: "restrictions", zoneId: "zoneId", accept: "accept" }, outputs: { onBlur: "blur", cancel: "cancel", clear: "clear", complete: "complete", error: "error", onFocus: "focus", pause: "pause", remove: "remove", resume: "resume", select: "select", success: "success", upload: "upload", uploadProgress: "uploadProgress", valueChange: "valueChange" }, exportAs: ["kendoUpload"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            NavigationService,
            UploadService,
            DropZoneService,
            UPLOAD_VALUE_ACCESSOR,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.upload'
            },
            {
                provide: KendoInput,
                useExisting: forwardRef(() => UploadComponent)
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 16, consts: [["kendoUploadLocalizedMessages", "", 6, "cancel", "clearSelectedFiles", "dropFilesHere", "filesBatchStatus", "filesBatchStatusFailed", "filesBatchStatusUploaded", "fileStatusFailed", "fileStatusUploaded", "headerStatusPaused", "headerStatusUploaded", "headerStatusUploading", "invalidFileExtension", "invalidMaxFileSize", "invalidMinFileSize", "pause", "remove", "resume", "retry", "select", "uploadSelectedFiles"], ["kendoUploadInternalDropZone", "", 3, "restrictions", "multiple", "disabled"], ["role", "button", 1, "k-button", "k-upload-button", 3, "id", "focus", "blur"], ["fileSelectButton", ""], ["kendoFileSelect", "", 3, "dir", "restrictions", "multiple", "disabled"], ["fileSelect", ""], ["class", "k-upload-status k-upload-status-total", 3, "fileList", 4, "ngIf"], [1, "k-dropzone-hint"], ["kendo-upload-file-list", "", "class", "k-upload-files k-reset", 3, "disabled", "fileList", "fileTemplate", 4, "ngIf"], [3, "disabled", 4, "ngIf"], [1, "k-upload-status", "k-upload-status-total", 3, "fileList"], ["kendo-upload-file-list", "", 1, "k-upload-files", "k-reset", 3, "disabled", "fileList", "fileTemplate"], [3, "disabled"]], template: function UploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c63);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function UploadComponent_Template_div_focus_3_listener($event) { return ctx.onFileSelectButtonFocus($event); })("blur", function UploadComponent_Template_div_blur_3_listener($event) { return ctx.onFileSelectButtonBlur($event); });
        ɵngcc0.ɵɵelement(5, "input", 4, 5);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, UploadComponent_kendo_upload_status_total_9_Template, 1, 1, "kendo-upload-status-total", 6);
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, UploadComponent_ul_12_Template, 1, 3, "ul", 8);
        ɵngcc0.ɵɵtemplate(13, UploadComponent_kendo_upload_action_buttons_13_Template, 1, 1, "kendo-upload-action-buttons", 9);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("restrictions", ctx.restrictions)("multiple", ctx.multiple)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.focusableId);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("select"))("tabindex", ctx.selectButtonTabIndex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("dir", ctx.direction)("restrictions", ctx.restrictions)("multiple", ctx.multiple)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("accept", ctx.accept ? ctx.accept : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("select"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showTotalStatus);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("dropFilesHere"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFileList && ctx.fileList.count > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActionButtons);
    } }, directives: function () { return [LocalizedMessagesDirective, DropZoneInternalDirective, FileSelectDirective, ɵngcc3.NgIf, UploadStatusTotalComponent, FileListComponent, UploadActionButtonsComponent]; }, encapsulation: 2 });
/** @nocollapse */
UploadComponent.ctorParameters = () => [
    { type: UploadService },
    { type: LocalizationService },
    { type: NavigationService },
    { type: DropZoneService },
    { type: NgZone },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
UploadComponent.propDecorators = {
    autoUpload: [{ type: Input }],
    batch: [{ type: Input }],
    withCredentials: [{ type: Input }],
    saveField: [{ type: Input }],
    saveHeaders: [{ type: Input }],
    saveMethod: [{ type: Input }],
    saveUrl: [{ type: Input }],
    responseType: [{ type: Input }],
    removeField: [{ type: Input }],
    removeHeaders: [{ type: Input }],
    removeMethod: [{ type: Input }],
    removeUrl: [{ type: Input }],
    chunkable: [{ type: Input }],
    concurrent: [{ type: Input }],
    multiple: [{ type: Input }],
    disabled: [{ type: Input }],
    showFileList: [{ type: Input }],
    tabindex: [{ type: Input }],
    zoneId: [{ type: Input }],
    tabIndex: [{ type: Input, args: ['tabIndex',] }],
    accept: [{ type: Input }],
    restrictions: [{ type: Input }],
    focusableId: [{ type: Input }],
    fileTemplate: [{ type: ContentChild, args: [FileTemplateDirective,] }],
    fileSelect: [{ type: ViewChild, args: ['fileSelect',] }],
    fileSelectButton: [{ type: ViewChild, args: ['fileSelectButton',] }],
    onBlur: [{ type: Output, args: ['blur',] }],
    cancel: [{ type: Output }],
    clear: [{ type: Output }],
    complete: [{ type: Output }],
    error: [{ type: Output }],
    onFocus: [{ type: Output, args: ['focus',] }],
    pause: [{ type: Output }],
    remove: [{ type: Output }],
    resume: [{ type: Output }],
    select: [{ type: Output }],
    success: [{ type: Output }],
    upload: [{ type: Output }],
    uploadProgress: [{ type: Output }],
    valueChange: [{ type: Output }],
    hostDefaultClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-upload',] }],
    hostDisabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }],
    handleKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoUpload',
                providers: [
                    LocalizationService,
                    NavigationService,
                    UploadService,
                    DropZoneService,
                    UPLOAD_VALUE_ACCESSOR,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.upload'
                    },
                    {
                        provide: KendoInput,
                        useExisting: forwardRef(() => UploadComponent)
                    }
                ],
                selector: 'kendo-upload',
                template: `
    <ng-container kendoUploadLocalizedMessages
      i18n-cancel="kendo.upload.cancel|The text for the Cancel button"
      cancel="Cancel"

      i18n-clearSelectedFiles="kendo.upload.clearSelectedFiles|The text for the Clear button"
      clearSelectedFiles="Clear"

      i18n-dropFilesHere="kendo.upload.dropFilesHere|The drop zone hint"
      dropFilesHere="Drop files here to upload"

      i18n-filesBatchStatus="kendo.upload.filesBatchStatus|The status message for a batch of files"
      filesBatchStatus="files"

      i18n-filesBatchStatusFailed="kendo.upload.filesBatchStatusFailed|The status message for a batch of files after failed upload"
      filesBatchStatusFailed="files failed to upload."

      i18n-filesBatchStatusUploaded="kendo.upload.filesBatchStatusUploaded|The status message for a batch of files after successful upload"
      filesBatchStatusUploaded="files successfully uploaded."

      i18n-fileStatusFailed="kendo.upload.fileStatusFailed|The file status message after failed upload"
      fileStatusFailed="File failed to upload."

      i18n-fileStatusUploaded="kendo.upload.fileStatusUploaded|The file status message after successful upload"
      fileStatusUploaded="File successfully uploaded."

      i18n-headerStatusPaused="kendo.upload.headerStatusPaused|The header status message when the file upload is paused"
      headerStatusPaused="Paused"

      i18n-headerStatusUploaded="kendo.upload.headerStatusUploaded|The header status message after file upload completion"
      headerStatusUploaded="Done"

      i18n-headerStatusUploading="kendo.upload.headerStatusUploading|The header status message during file upload"
      headerStatusUploading="Uploading..."

      i18n-invalidFileExtension="kendo.upload.invalidFileExtension|The text for the invalid allowed extensions restriction message"
      invalidFileExtension="File type not allowed."

      i18n-invalidMaxFileSize="kendo.upload.invalidMaxFileSize|The text for the invalid max file size restriction message"
      invalidMaxFileSize="File size too large."

      i18n-invalidMinFileSize="kendo.upload.invalidMinFileSize|The text for the invalid min file size restriction message"
      invalidMinFileSize="File size too small."

      i18n-pause="kendo.upload.pause|The text for the Pause button"
      pause="Pause"

      i18n-remove="kendo.upload.remove|The text for the Remove button"
      remove="Remove"

      i18n-resume="kendo.upload.resume|The text for the Resume button"
      resume="Resume"

      i18n-retry="kendo.upload.retry|The text for the Retry button"
      retry="Retry"

      i18n-select="kendo.upload.select|The text for the Select button"
      select="Select files..."

      i18n-uploadSelectedFiles="kendo.upload.uploadSelectedFiles|The text for the Upload files button"
      uploadSelectedFiles="Upload"
    >
    </ng-container>
    <div kendoUploadInternalDropZone
      [restrictions]="restrictions"
      [multiple]="multiple"
      [disabled]="disabled">
        <div role="button" #fileSelectButton
             [id]="focusableId"
             [attr.aria-label]="textFor('select')"
             [attr.tabindex]="selectButtonTabIndex"
             (focus)="onFileSelectButtonFocus($event)"
             (blur)="onFileSelectButtonBlur($event)"
             class="k-button k-upload-button">
          <input #fileSelect kendoFileSelect
            [attr.accept]="accept ? accept : null"
            [dir]="direction"
            [restrictions]="restrictions"
            [multiple]="multiple"
            [disabled]="disabled" />
          <span>{{textFor('select')}}</span>
        </div>
        <kendo-upload-status-total *ngIf="showTotalStatus"
          class="k-upload-status k-upload-status-total"
          [fileList]="fileList">
        </kendo-upload-status-total>
        <div class="k-dropzone-hint">{{textFor('dropFilesHere')}}</div>
    </div>
    <ul kendo-upload-file-list *ngIf="showFileList && fileList.count > 0"
        class="k-upload-files k-reset"
        [disabled]="disabled"
        [fileList]="fileList.files"
        [fileTemplate]="fileTemplate">
    </ul>
    <kendo-upload-action-buttons
      *ngIf="showActionButtons"
      [disabled]="disabled">
    </kendo-upload-action-buttons>
  `
            }]
    }], function () { return [{ type: UploadService }, { type: ɵngcc2.LocalizationService }, { type: NavigationService }, { type: DropZoneService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { chunkable: [{
            type: Input
        }], multiple: [{
            type: Input
        }], disabled: [{
            type: Input
        }], showFileList: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], focusableId: [{
            type: Input
        }], onBlur: [{
            type: Output,
            args: ['blur']
        }], cancel: [{
            type: Output
        }], clear: [{
            type: Output
        }], complete: [{
            type: Output
        }], error: [{
            type: Output
        }], onFocus: [{
            type: Output,
            args: ['focus']
        }], pause: [{
            type: Output
        }], remove: [{
            type: Output
        }], resume: [{
            type: Output
        }], select: [{
            type: Output
        }], success: [{
            type: Output
        }], upload: [{
            type: Output
        }], uploadProgress: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], hostDefaultClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-upload']
        }], autoUpload: [{
            type: Input
        }], batch: [{
            type: Input
        }], withCredentials: [{
            type: Input
        }], saveField: [{
            type: Input
        }], saveHeaders: [{
            type: Input
        }], saveMethod: [{
            type: Input
        }], saveUrl: [{
            type: Input
        }], responseType: [{
            type: Input
        }], removeField: [{
            type: Input
        }], removeHeaders: [{
            type: Input
        }], removeMethod: [{
            type: Input
        }], removeUrl: [{
            type: Input
        }], concurrent: [{
            type: Input
        }], tabIndex: [{
            type: Input,
            args: ['tabIndex']
        }], restrictions: [{
            type: Input
        }], hostDisabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], 
    /**
     * @hidden
     */
    handleKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], zoneId: [{
            type: Input
        }], accept: [{
            type: Input
        }], fileTemplate: [{
            type: ContentChild,
            args: [FileTemplateDirective]
        }], fileSelect: [{
            type: ViewChild,
            args: ['fileSelect']
        }], fileSelectButton: [{
            type: ViewChild,
            args: ['fileSelectButton']
        }] }); })();

class UploadDropZoneDirective {
    constructor(dropZoneService) {
        this.dropZoneService = dropZoneService;
    }
    /**
     * @hidden
     */
    onElementDragEnter() {
        return false;
    }
    /**
     * @hidden
     */
    onElementDragOver() {
        return false;
    }
    /**
     * @hidden
     */
    onDropListener(event) {
        const components = this.componentInstance;
        if (!isPresent(components)) {
            return;
        }
        components.forEach((component) => {
            let droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 0 && !component.disabled) {
                let files = getAllFileInfo(droppedFiles);
                if (component instanceof UploadComponent) {
                    files = assignGuidToFiles(files, !component.batch);
                }
                else {
                    files = assignGuidToFiles(files, true);
                }
                if (!component.multiple) {
                    files.splice(1, files.length - 1);
                    component.clearFiles();
                }
                validateFiles(files, component.restrictions);
                component.addFiles(files);
            }
        });
        return false;
    }
    /**
     * @hidden
     */
    get componentInstance() {
        return this.dropZoneService.getComponents(this.zoneId);
    }
}
UploadDropZoneDirective.ɵfac = function UploadDropZoneDirective_Factory(t) { return new (t || UploadDropZoneDirective)(ɵngcc0.ɵɵdirectiveInject(DropZoneService)); };
UploadDropZoneDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: UploadDropZoneDirective, selectors: [["", "kendoUploadDropZone", ""], ["", "kendoFileSelectDropZone", ""]], hostBindings: function UploadDropZoneDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragenter", function UploadDropZoneDirective_dragenter_HostBindingHandler() { return ctx.onElementDragEnter(); })("dragover", function UploadDropZoneDirective_dragover_HostBindingHandler() { return ctx.onElementDragOver(); })("drop", function UploadDropZoneDirective_drop_HostBindingHandler($event) { return ctx.onDropListener($event); });
    } }, inputs: { zoneId: ["kendoUploadDropZone", "zoneId"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            DropZoneService
        ])] });
/** @nocollapse */
UploadDropZoneDirective.ctorParameters = () => [
    { type: DropZoneService }
];
UploadDropZoneDirective.propDecorators = {
    zoneId: [{ type: Input, args: ['kendoUploadDropZone',] }],
    onElementDragEnter: [{ type: HostListener, args: ['dragenter',] }],
    onElementDragOver: [{ type: HostListener, args: ['dragover',] }],
    onDropListener: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadDropZoneDirective, [{
        type: Directive,
        args: [{
                providers: [
                    DropZoneService
                ],
                selector: '[kendoUploadDropZone], [kendoFileSelectDropZone]'
            }]
    }], function () { return [{ type: DropZoneService }]; }, { 
    /**
     * @hidden
     */
    onElementDragEnter: [{
            type: HostListener,
            args: ['dragenter']
        }], 
    /**
     * @hidden
     */
    onElementDragOver: [{
            type: HostListener,
            args: ['dragover']
        }], 
    /**
     * @hidden
     */
    onDropListener: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], zoneId: [{
            type: Input,
            args: ['kendoUploadDropZone']
        }] }); })();

/* tslint:disable: no-use-before-declare */
/**
 * Represents the [Kendo UI UploadDropZone component for Angular]({% slug overview_upload %}).
 */
class UploadDropZoneComponent extends DropZoneBase {
    constructor(element, renderer, localization) {
        super(element, renderer, 'k-external-dropzone-hover');
        this.localization = localization;
        this.hostClass = true;
        this.localizationChangeSubscription = this.localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
    }
    get dirAttribute() {
        return this.direction;
    }
    /**
     * @hidden
     */
    textFor(key) {
        return this.localization.get(key);
    }
    /**
     * @hidden
     */
    get iconClasses() {
        if (this.icon) {
            return `k-icon k-i-${this.icon}`;
        }
        if (this.iconClass) {
            return `${this.iconClass}`;
        }
        return 'k-icon k-i-upload';
    }
    ngOnDestroy() {
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
    }
}
UploadDropZoneComponent.ɵfac = function UploadDropZoneComponent_Factory(t) { return new (t || UploadDropZoneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
UploadDropZoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadDropZoneComponent, selectors: [["kendo-uploaddropzone"]], hostVars: 3, hostBindings: function UploadDropZoneComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dirAttribute);
        ɵngcc0.ɵɵclassProp("k-external-dropzone", ctx.hostClass);
    } }, inputs: { zoneId: "zoneId", icon: "icon", iconClass: "iconClass" }, exportAs: ["kendoUploadDropZone"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.uploaddropzone'
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c67, decls: 8, vars: 3, consts: [["kendoUploadDropZoneLocalizedMessages", "", 6, "externalDropFilesHere"], [1, "k-dropzone-inner", 3, "kendoUploadDropZone"], [3, "ngClass"], [1, "k-dropzone-hint"], [1, "k-dropzone-note"]], template: function UploadDropZoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c66);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "span", 2);
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("kendoUploadDropZone", ctx.zoneId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.iconClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.textFor("externalDropFilesHere"));
    } }, directives: [LocalizedMessagesDirective, UploadDropZoneDirective, ɵngcc3.NgClass], encapsulation: 2 });
/** @nocollapse */
UploadDropZoneComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: LocalizationService }
];
UploadDropZoneComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-external-dropzone',] }],
    dirAttribute: [{ type: HostBinding, args: ['attr.dir',] }],
    zoneId: [{ type: Input }],
    icon: [{ type: Input }],
    iconClass: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadDropZoneComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoUploadDropZone',
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.uploaddropzone'
                    }
                ],
                selector: 'kendo-uploaddropzone',
                template: `
    <ng-container kendoUploadDropZoneLocalizedMessages
      i18n-externalDropFilesHere='kendo.uploaddropzone.externalDropFilesHere|Sets the external drop-zone hint'
      externalDropFilesHere='Drag and drop files here to upload'
    >
    </ng-container>
    <div class='k-dropzone-inner' [kendoUploadDropZone]="zoneId">
      <span [ngClass]="iconClasses"></span>
      <span class="k-dropzone-hint">{{ textFor('externalDropFilesHere') }}</span>
      <span class="k-dropzone-note">
        <ng-content></ng-content>
      </span>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.LocalizationService }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-external-dropzone']
        }], dirAttribute: [{
            type: HostBinding,
            args: ['attr.dir']
        }], zoneId: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconClass: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
const SHARED_DECLARATIONS = [
    DropZoneInternalDirective,
    FileListComponent,
    FileListItemDirective,
    FileListItemActionButtonComponent,
    FileListMultipleItemsComponent,
    FileListSingleItemComponent,
    FileSelectDirective,
    LocalizedMessagesDirective,
    TemplateContextDirective
];
/**
 * @hidden
 */
const PUBLIC_DIRECTIVES = [
    FileTemplateDirective,
    CustomMessagesComponent,
    UploadDropZoneDirective,
    UploadDropZoneComponent
];
/**
 * @hidden
 */
class SharedModule {
}
SharedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SharedModule_Factory(t) { return new (t || SharedModule)(); }, imports: [[CommonModule], CommonModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedModule, { declarations: function () { return [FileTemplateDirective, CustomMessagesComponent, UploadDropZoneDirective, UploadDropZoneComponent, DropZoneInternalDirective, FileListComponent, FileListItemDirective, FileListItemActionButtonComponent, FileListMultipleItemsComponent, FileListSingleItemComponent, FileSelectDirective, LocalizedMessagesDirective, TemplateContextDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FileTemplateDirective, CustomMessagesComponent, UploadDropZoneDirective, UploadDropZoneComponent, DropZoneInternalDirective, FileListComponent, FileListItemDirective, FileListItemActionButtonComponent, FileListMultipleItemsComponent, FileListSingleItemComponent, FileSelectDirective, LocalizedMessagesDirective, TemplateContextDirective, CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PUBLIC_DIRECTIVES,
                    SHARED_DECLARATIONS
                ],
                exports: [
                    PUBLIC_DIRECTIVES,
                    SHARED_DECLARATIONS,
                    CommonModule
                ],
                imports: [CommonModule]
            }]
    }], null, null); })();

const FILESELECT_DECLARATIONS = [
    FileSelectComponent
];
/**
 * Represents the [NgModule](https://angular.io/api/core/NgModule) definition for the FileSelect component.
 */
class FileSelectModule {
}
FileSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FileSelectModule });
FileSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FileSelectModule_Factory(t) { return new (t || FileSelectModule)(); }, imports: [[SharedModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileSelectModule, { declarations: [FileSelectComponent], imports: [SharedModule], exports: [FileTemplateDirective, CustomMessagesComponent, UploadDropZoneDirective, UploadDropZoneComponent, FileSelectComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [FILESELECT_DECLARATIONS],
                exports: [
                    PUBLIC_DIRECTIVES,
                    FILESELECT_DECLARATIONS
                ],
                imports: [SharedModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class UploadActionButtonsComponent {
    constructor(uploadService, localization, navigation) {
        this.uploadService = uploadService;
        this.localization = localization;
        this.navigation = navigation;
        this.onAction();
        this.onFocus();
    }
    onAction() {
        this.actionSubscription = this.navigation.onActionButtonAction.subscribe((button) => {
            if (button === "clear") {
                this.clearFiles();
            }
            else {
                this.performUpload();
            }
            this.navigation.focusSelectButton();
        });
    }
    onFocus() {
        this.focusSubscription = this.navigation.onActionButtonFocus.subscribe((button) => {
            this.focusButton(button);
        });
    }
    focusButton(button) {
        const el = (button === "clear") ? this.clearButton : this.uploadButton;
        el.nativeElement.focus();
    }
    ngOnDestroy() {
        this.actionSubscription.unsubscribe();
        this.focusSubscription.unsubscribe();
    }
    performUpload(_event) {
        if (!this.disabled) {
            this.uploadService.uploadFiles();
        }
    }
    clearFiles(_event) {
        if (!this.disabled) {
            this.uploadService.clearFiles();
        }
    }
    textFor(key) {
        return this.localization.get(key);
    }
    get className() {
        return 'k-action-buttons';
    }
}
UploadActionButtonsComponent.ɵfac = function UploadActionButtonsComponent_Factory(t) { return new (t || UploadActionButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(UploadService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(NavigationService)); };
UploadActionButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadActionButtonsComponent, selectors: [["kendo-upload-action-buttons"]], viewQuery: function UploadActionButtonsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c68, true);
        ɵngcc0.ɵɵviewQuery(_c69, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.clearButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.uploadButton = _t.first);
    } }, hostVars: 2, hostBindings: function UploadActionButtonsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.className);
    } }, inputs: { disabled: "disabled" }, decls: 6, vars: 4, consts: [["type", "button", 1, "k-button", "k-clear-selected", 3, "click"], ["clearButton", ""], ["type", "button", 1, "k-button", "k-primary", "k-upload-selected", 3, "click"], ["uploadButton", ""]], template: function UploadActionButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function UploadActionButtonsComponent_Template_button_click_0_listener($event) { return ctx.clearFiles($event); });
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2, 3);
        ɵngcc0.ɵɵlistener("click", function UploadActionButtonsComponent_Template_button_click_3_listener($event) { return ctx.performUpload($event); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", 0 - 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("clearSelectedFiles"), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("tabIndex", 0 - 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("uploadSelectedFiles"), " ");
    } }, encapsulation: 2 });
/** @nocollapse */
UploadActionButtonsComponent.ctorParameters = () => [
    { type: UploadService },
    { type: LocalizationService },
    { type: NavigationService }
];
UploadActionButtonsComponent.propDecorators = {
    disabled: [{ type: Input }],
    clearButton: [{ type: ViewChild, args: ['clearButton',] }],
    uploadButton: [{ type: ViewChild, args: ['uploadButton',] }],
    className: [{ type: HostBinding, args: ['class',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadActionButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-upload-action-buttons',
                template: `
        <button #clearButton type="button" class="k-button k-clear-selected"
            [attr.tabIndex]="-1"
            (click)="clearFiles($event)">
                {{textFor('clearSelectedFiles')}}
        </button>
        <button #uploadButton type="button" class="k-button k-primary k-upload-selected"
            [attr.tabIndex]="-1"
            (click)="performUpload($event)">
                {{textFor('uploadSelectedFiles')}}
        </button>
    `
            }]
    }], function () { return [{ type: UploadService }, { type: ɵngcc2.LocalizationService }, { type: NavigationService }]; }, { className: [{
            type: HostBinding,
            args: ['class']
        }], disabled: [{
            type: Input
        }], clearButton: [{
            type: ViewChild,
            args: ['clearButton']
        }], uploadButton: [{
            type: ViewChild,
            args: ['uploadButton']
        }] }); })();

/**
 * @hidden
 */
class UploadStatusTotalComponent {
    constructor(localization) {
        this.localization = localization;
    }
    ngDoCheck() {
        this.isPaused = this.fileList.hasFileWithState([FileState.Paused]);
        this.isFailed = this.fileList.hasFileWithState([FileState.Failed]);
        this.isUploading = this.fileList.hasFileWithState([FileState.Uploading]);
        if (this.isPaused && !this.isUploading) {
            this.statusText = this.localization.get('headerStatusPaused');
        }
        else {
            this.statusText = this.isUploading ? this.localization.get('headerStatusUploading')
                : this.localization.get('headerStatusUploaded');
        }
    }
}
UploadStatusTotalComponent.ɵfac = function UploadStatusTotalComponent_Factory(t) { return new (t || UploadStatusTotalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
UploadStatusTotalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadStatusTotalComponent, selectors: [["kendo-upload-status-total"]], inputs: { fileList: "fileList" }, decls: 2, vars: 7, consts: [[1, "k-icon", 3, "ngClass"]], template: function UploadStatusTotalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(2, _c70, !ctx.isUploading && !ctx.isFailed, !ctx.isUploading && ctx.isFailed, ctx.isUploading, ctx.isPaused));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.statusText, " ");
    } }, directives: [ɵngcc3.NgClass], encapsulation: 2 });
/** @nocollapse */
UploadStatusTotalComponent.ctorParameters = () => [
    { type: LocalizationService }
];
UploadStatusTotalComponent.propDecorators = {
    fileList: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadStatusTotalComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-upload-status-total',
                template: `
        <span class="k-icon"
            [ngClass]="{
                'k-i-checkmark': !this.isUploading && !this.isFailed,
                'k-i-exception': !this.isUploading && this.isFailed,
                'k-i-upload': this.isUploading,
                'k-i-pause-sm': this.isPaused
            }">
        </span>
        {{statusText}}
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, { fileList: [{
            type: Input
        }] }); })();

const UPLOAD_DECLARATIONS = [
    UploadComponent,
    UploadActionButtonsComponent,
    UploadStatusTotalComponent
];
/**
 * Represents the [NgModule](https://angular.io/api/core/NgModule) definition for the Upload component.
 */
class UploadModule {
}
UploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UploadModule });
UploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UploadModule_Factory(t) { return new (t || UploadModule)(); }, imports: [[SharedModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UploadModule, { declarations: [UploadComponent, UploadActionButtonsComponent, UploadStatusTotalComponent], imports: [SharedModule], exports: [FileTemplateDirective, CustomMessagesComponent, UploadDropZoneDirective, UploadDropZoneComponent, UploadComponent, UploadActionButtonsComponent, UploadStatusTotalComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadModule, [{
        type: NgModule,
        args: [{
                declarations: [UPLOAD_DECLARATIONS],
                exports: [
                    PUBLIC_DIRECTIVES,
                    UPLOAD_DECLARATIONS
                ],
                imports: [SharedModule]
            }]
    }], null, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Uploads components.
 *
 * @example
 *
 * ```ts-no-run
 * import { UploadsModule } from '@progress/kendo-angular-upload';
 *
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { NgModule } from '@angular/core';
 *
 * import { AppComponent } from './app.component';
 *
 * _@NgModule({
 *     declarations: [AppComponent],
 *     imports:      [BrowserModule, UploadsModule],
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class UploadsModule {
}
UploadsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UploadsModule });
UploadsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UploadsModule_Factory(t) { return new (t || UploadsModule)(); }, imports: [FileSelectModule, UploadModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UploadsModule, { exports: [FileSelectModule, UploadModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadsModule, [{
        type: NgModule,
        args: [{
                exports: [
                    FileSelectModule,
                    UploadModule
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DropZoneBase, DropZoneInternalDirective, DropZoneService, PreventableEvent, FILESELECT_VALUE_ACCESSOR, LocalizedMessagesDirective, Messages, NavigationService, FileListItemDirective, FileListItemBase, PUBLIC_DIRECTIVES, SHARED_DECLARATIONS, SharedModule, UPLOAD_VALUE_ACCESSOR, UploadService, FileSelectModule, UploadModule, UploadsModule, UploadComponent, FileSelectComponent, UploadDropZoneComponent, FileSelectDirective, FileListComponent, FileListSingleItemComponent, FileListItemActionButtonComponent, FileListMultipleItemsComponent, FileTemplateDirective, TemplateContextDirective, UploadStatusTotalComponent, UploadActionButtonsComponent, UploadDropZoneDirective, CustomMessagesComponent, CancelEvent, ClearEvent, ErrorEvent, PauseEvent, RemoveEvent, ResumeEvent, SelectEvent, SuccessEvent, UploadEvent, UploadProgressEvent, FileState };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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